"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//this file exports a list of enzymes grouped together by similarities
var aliasedEnzymes = [{
  aliases: ["ErpI", "Bme18I", "BsrAI", "SmuEI", "FdiI", "BmpI", "VpaK11BI", "CauI", "Kzo49I", "SinI", "EagMI", "HgiHIII", "AvaII", "BamNxI", "AflI", "FssI", "Asp745I", "BthAI", "HgiCII", "FspMSI", "DsaIV", "Eco47I", "Csp68KI", "BcuAI", "HgiEI", "HgiJI", "HgiBI", "Bme216I"],
  site: "ggwcc",
  forwardRegex: "g{2}[atw]c{2}",
  reverseRegex: "g{2}[atw]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["Eco196I", "Uba1126I", "Pae17I", "Ssp1725I", "BacI", "Eco104I", "Bsp12I", "Eco100I", "EccI", "Kpn19I", "DrdFI", "Cfr37I", "DrdEI", "DrdBI", "DrdAI", "DrdCI", "Cfr45II", "FscI", "Cte1I", "Pfl1108II", "NlaSI", "Ecl1I", "Bac465I", "Uba66I", "NgoDIII", "NgoJIII", "Pae7I", "Dsp1I", "SseII", "BscTI", "MraI", "Pae36I", "SsmII", "NlaDIII", "Eco55I", "Uba77I", "Uba1364I", "Uba1369I", "Pae44I", "Pae43I", "Pae42I", "Sfr382I", "Ese3I", "Ese6I", "SfrI", "Cfr43I", "Cfr41I", "Uba1234I", "StaI", "Uba90I", "NgoKIII", "Eco151I", "Eco208I", "Uba1306I", "Ecl28I", "Eco158I", "TtoI", "Uba1244I", "Asp32HI", "SboI", "Eco134I", "Eco135I", "SenpCI", "ShyI", "TglI", "UbaHKAI", "NgoGIII", "NgoMIII", "Eco96I", "SakI", "Eco92I", "Ssm5II", "SaaI", "SabI", "Uba1111I", "AosIII", "Uba1113I", "Eco182I", "Eco99I", "Uba1187I", "Uba1095I", "Uba1093I", "Ecl37I", "Uba1229I"],
  site: "ccgcgg",
  forwardRegex: "c{2}gcg{2}",
  reverseRegex: "c{2}gcg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SplI", "PpuAI", "BvuBI", "Pfl23II", "PspLI", "SunI", "BsiWI", "BpuB5I", "MaeK81I"],
  site: "cgtacg",
  forwardRegex: "cgtacg",
  reverseRegex: "cgtacg",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Uba1366II", "Bsh108AI", "Uba1161I", "Uba1379I", "BfrAI", "BscVI", "Uba1145I", "Uba1257I", "Uba1144I", "Bsp145I", "Apu16I", "Uba1138I", "Uba1286I", "Bth1202I", "Uba1137I", "Uba1133I", "Bli576I", "Bsp84I", "Uba1427I", "BstLVI", "Uba1200I", "Bsp127I", "Bsp126I", "Bsp125I", "Uba1275I", "Bli585I", "BazI", "Uba1412I", "Uba1342I", "Uba1416I", "Uba1195I", "Uba1197I", "Uba1196I", "Bth9415I", "Uba1295I", "Uba1096I", "Bco79I", "Bsp2I", "Uba43I", "Bsp4I", "Uba34I", "Asp86I", "Asp14I", "Uba1430I", "Uba1100I", "Csp4I", "Uba1198I", "Uba1199I", "Uba30I", "Asp123I", "Uba1246I", "Uba22I", "Uba24I", "Asp707I", "BsrCI", "Uba1168I", "Uba1315I", "Uba1394I", "Asp37I", "Uba1233I", "Uba1238I", "Asp130I", "BtuI", "Uba1451I", "Uba1453I", "Uba1380I"],
  site: "atcgat",
  forwardRegex: "atcgat",
  reverseRegex: "atcgat",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bbv12I", "MspV281I", "BsiHKAI", "Alw21I", "Bsm6I", "Bsh45I", "AspHI", "HgiAI"],
  site: "gwgcwc",
  forwardRegex: "g[atw]gc[atw]c",
  reverseRegex: "g[atw]gc[atw]c",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["SmiMII", "NflAI", "Rma495II", "Bsc217I", "Tsp273I", "Eco17I", "NanI", "Eco178I", "BshLI", "Bsp16I", "Pac1110II", "BsoAI", "PxyARI", "UbaN4I", "Rma497II", "Rma496II", "Uba1400I", "BstRI", "Pfl16I"],
  site: "gatatc",
  forwardRegex: "gatatc",
  reverseRegex: "gatatc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Uba1223I", "MthTI", "Bpa36I", "Bce71I", "NgoCII", "SagI", "Bal3006I", "Uba9I", "NlaI", "Uba1449I", "HhgI", "Bsu1114I", "Uba1336I", "Bfi458I", "Uba1228I", "Bsp23I", "Uba1097I", "Uba1214I", "Tsp266I", "TteAI", "Uba1210I", "Afl83II", "BmeU1594I", "Uba1322I", "Bme46I", "Bsp2500I", "Csp2I", "UbaN8I", "MniI", "BshAI", "BshDI", "BshEI", "Van91III", "BshBI", "BshCI", "Bsp2013I", "HpyF10V", "NgoAII", "SulI", "BsiDI", "BsiAI", "Uba1169I", "NgoNII", "Uba1319I", "BliI", "BsiHI", "Uba1392I", "Uba1395I", "Uba1231I", "BsaRI", "HpyF72I", "Uba1235I", "Uba1450I", "Bsp1261I", "Tsp132I", "Uba1230I", "FinSI", "Tsp281I", "Bsp2362I", "BssCI", "Uba1176I", "Uba1175I", "Uba1174I", "Uba1179I", "Uba1388I", "Uba1178I", "BspLRI", "Psp29I", "BspBDG2I", "Bsu1076I", "PaiI", "TtnI", "Bse126I", "Bsp137I", "BstJI", "HpyF69II", "Uba1150I", "HpyF63I", "Uba1152I", "Bal475I", "HpyF26II", "Uba1153I", "Uba1155I", "BhaII", "Uth557I", "Tsp273II", "Uba1408I", "Uth555I", "Bco33I", "PpuI", "BscQI", "Uba1377I", "Bme74I", "HpyF33II", "VniI", "BstCI", "BluII", "AspTIII", "Tsp560I", "Uba1146I", "HpyF57I", "Uba1147I", "HpyF53I", "BseI", "Uba1140I", "Bsp881I", "M.H2I", "HpyF73III", "Vha1168I", "M.Csp68KV", "TspZNI", "HpyF49IV", "Uth549I", "BspBSE18I", "HpyF42I", "UbaN2I", "Uba1288I", "Uba1209I", "Uba1208I", "EsaWC1I", "HpyF46V", "Uba1207I", "Asp742I", "ClmI", "Bse9I", "Bsp44II", "Uba1429I", "BspCHE15I", "Uba61I", "OchI", "NgoSII", "Uba1422I", "Hpy178VII", "Uba1292I", "SplIII", "Uba1293I", "Bsp1593I", "MnnII", "Bsp226I", "BspBake1I", "AcaIV", "M.NgoGII", "Uba1418I", "VhaI", "Uba54I", "BspGHA1I", "BspH106II", "Psb9879I", "Ple214I", "NgoTII", "AvrBI", "HpyF29I"],
  site: "ggcc",
  forwardRegex: "g{2}c{2}",
  reverseRegex: "g{2}c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["ErhB9I", "Afa16RI", "XorII", "NblI", "Ple19I", "RshI", "BpvUI", "Afa22MI", "PvuI", "Psu161I", "EagBI", "MvrI", "BspCI"],
  site: "cgatcg",
  forwardRegex: "cgatcg",
  reverseRegex: "cgatcg",
  topSnipOffset: 4,
  bottomSnipOffset: 2
}, {
  aliases: ["BsmRI", "Ssp4800I", "Bsp1407I", "BstAUI", "BsrGI", "SspBI", "AauI"],
  site: "tgtaca",
  forwardRegex: "tgtaca",
  reverseRegex: "tgtaca",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Psp32I", "Acs1422I", "Acs1421I", "BstZ16I", "Acs1371I", "Acs1372I", "Acs1373I", "CglAII", "RhpI", "RheI", "Psp89I", "XamI", "RroI", "RrhI", "Uba89I", "BtgAI", "Psp33I", "KoyI"],
  site: "gtcgac",
  forwardRegex: "gtcgac",
  reverseRegex: "gtcgac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Ecl136I", "Scg2I", "Bme2095I", "Ecl1zII", "Bsp56I", "Esp2I", "Eco70I", "Eco71I", "Eco206I", "Asp2HI", "Eco207I", "Uba1181I", "M.SPRI", "Eco67I", "Uba1185I", "Uba13I", "Acc38I", "Uba11I", "CfrS37I", "BsaNI", "Uba20I", "Bsp44I", "Ese6II", "SflHK7462I", "Cdi27I", "Sau16I", "Uba1171I", "BsiUI", "Uba1243I", "BsiVI", "UbaN16I", "Bsp103I", "Uba1218I", "Eco128I", "BspSI", "SflHK7234I", "SflHK2374I", "Eco170I", "Cfr11I", "Esp24I", "M.EcoKDcm", "AcuII", "EagKI", "Cfr5I", "Bsp317I", "Ecl37kII", "EcaII", "Uba1118I", "Bst7QII", "Uba1189I", "HhdI", "Uba1114I", "Uba1193I", "SflHK8401I", "BstGII", "Sfl2bI", "Uba1410I", "Sfl2aI", "Kpn16I", "Kpn14I", "Cfr35I", "Eco38I", "Kpn13I", "MpsI", "Ecl57kI", "Cfr31I", "Cfr30I", "EclII", "Uba1120I", "Uba1121I", "KspHK12I", "KspHK14I", "Eco256I", "Kpn10I", "TspAI", "Eco254I", "BsoGI", "Eco193I", "Cfr28I", "Cfr29I", "Uba1125I", "MphI", "Cfr27I", "Cfr25I", "Cfr24I", "Ecl66I", "EclS39I", "Uba1428I", "Cfr22I", "Lla497I", "Cfr20I", "EspHK7I", "Sgr20I", "Mlu2300I", "BspH43I", "EspHK30I", "Cfr58I", "Kox165I", "SflHK2731I", "UbaN11II", "Eco60I", "Ecl54kI", "Eco61I", "Sth455I", "SflHK10790I", "SflHK6873I", "BinSI", "Psp39I", "AtuBI", "Uba82I", "Uba81I", "Ecl137II", "Eco41I", "Eco40I", "AtuII", "SflHK1794I", "Atu1I", "Pca17AI", "M.Bbu297I", "EspHK22I"],
  site: "ccwgg",
  forwardRegex: "c{2}[atw]g{2}",
  reverseRegex: "c{2}[atw]g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SspCI", "NaeI", "SauLPI", "SauSI", "SauBMKI", "RrhJ1I", "SauHPI", "CcoI", "PdiI", "SauNI", "Slu1777I"],
  site: "gccggc",
  forwardRegex: "gc{2}g{2}c",
  reverseRegex: "gc{2}g{2}c",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["AflIV", "BstMI", "Uba1158I", "LlaDI", "VchO49I", "NmeSI", "PinI", "Asp763I", "BsoSI", "Uba1094I", "BshHI"],
  site: "agtact",
  forwardRegex: "agtact",
  reverseRegex: "agtact",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco190I", "Uba1280I", "Uba1347I", "RshII", "BspJ67I", "Uba1424I", "Uba1423I", "SflHK11086I", "Asp1I", "SflHK11087I", "BspF105I", "SflHK10695I", "Uba1372I", "Uba1370I", "Tmu1I", "Uba1378I", "Uba1401I", "Uba1376I", "Uba1389I", "Bsp55I", "SflHK11572I", "HgiS21I", "Uba1318I", "Pae181I", "Eco179I", "UbaN11I", "Eco121I", "Hin3I", "Bsp7I", "Bsp8I", "SflHK115731I", "Uba42I", "Uba41I", "EciDI", "Ssp2I"],
  site: "ccsgg",
  forwardRegex: "c{2}[cgs]g{2}",
  reverseRegex: "c{2}[cgs]g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AgeI", "CsiAI", "AsiAI", "AsiGI", "PinAI", "BshTI", "CspAI"],
  site: "accggt",
  forwardRegex: "ac{2}g{2}t",
  reverseRegex: "ac{2}g{2}t",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BtsI"],
  site: "gcagtg",
  forwardRegex: "gcagtg",
  reverseRegex: "cactgc",
  topSnipOffset: 8,
  bottomSnipOffset: 6,
  isType2S: true
}, {
  aliases: ["SteI", "Eco147I", "StuI", "PceI", "AatI", "SarI", "Pme55I", "GdiI", "Sru30DI", "SseBI", "Eco1524I", "AspMI"],
  site: "aggcct",
  forwardRegex: "ag{2}c{2}t",
  reverseRegex: "ag{2}c{2}t",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["HpyF10I", "HinS1I", "HinS2I", "Hin7I", "BcaI", "HinGUI", "Hpy99III", "Mho2965I", "Csp1470I", "MnnIV", "CcoP95I", "NgoEII"],
  site: "gcgc",
  forwardRegex: "gcgc",
  reverseRegex: "gcgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BceBI", "Bsp50I", "BtkI", "Bpu95I", "Csp68KVI", "BepI", "MvnI", "Bsh1236I", "AccII", "BstFNI", "FnuDII", "FalII", "FauBII", "Bsp123I", "ThaI", "BstUI", "BspFNI", "Bsu1532I"],
  site: "cgcg",
  forwardRegex: "cgcg",
  reverseRegex: "cgcg",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["TspBI", "BstDSI", "BtgI", "DsaI"],
  site: "ccrygg",
  forwardRegex: "c{2}[agr][cty]g{2}",
  reverseRegex: "c{2}[agr][cty]g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BecAII", "BspKI", "HaeIII", "PlaI", "BshFI", "BspBRI", "BspRI", "SuaI", "PhoI", "Pde133I", "SbvI", "NgoPII", "PalI", "PflKI", "BteI", "SfaI", "Bsp211I", "DsaII", "Bme361I", "BsuRI", "BshI", "BsnI", "CltI", "NspLKI", "MchAII", "EsaBC4I", "BspANI", "FnuDI", "BseQI", "Bim19II", "MfoAI", "BanAI", "Pru2I"],
  site: "ggcc",
  forwardRegex: "g{2}c{2}",
  reverseRegex: "g{2}c{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["CceI", "Bsp116I", "HpyF43I", "Uba1355I", "Asp748I", "M.Csp68KIV", "Uba1128I", "Uba1267I", "Pme35I", "SecII", "Uba1141I", "Bsp48I", "Bsp47I", "HpyVIII", "BsaZI", "FinII", "Hin5I", "SfaGUI", "Msp199I", "MniII", "Bsu1192I", "Uba1338I", "Bsp5I", "Bsp1591II", "BshMI", "UbaN13I", "Uba1439I"],
  site: "ccgg",
  forwardRegex: "c{2}g{2}",
  reverseRegex: "c{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Cfr10I", "Bse634I", "BssAI", "Bco118I", "Bse118I", "BstB7SI", "BsrFI"],
  site: "rccggy",
  forwardRegex: "[agr]c{2}g{2}[cty]",
  reverseRegex: "[agr]c{2}g{2}[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BseRI"],
  isType2S: true,
  site: "gaggag",
  forwardRegex: "gag{2}ag",
  reverseRegex: "ctc{2}tc",
  topSnipOffset: 16,
  bottomSnipOffset: 14
}, {
  aliases: ["MmaI", "XmaII", "XorI", "ScoAI", "VpaK29AI", "XveI", "Pph2066I", "Asp708I", "Bsp43I", "Uba1399I", "Eco161I", "Eco83I", "BloHIII", "Eco167I", "Uba1184I", "BsaQI", "Pma44I", "MkrI", "Ali2882I", "Uba1232I", "Asp36I", "Pph2059I", "Ecl133I", "EaePI", "SkaII", "Bsp268I", "Psp28I", "Uba1115I", "PmaI", "Uba1116I", "Ssp12I", "Uba1112I", "Bth9411I", "Uba46I", "Bsp17I", "Uba1225I", "Uba1294II", "Uba1296I", "PspSI", "Ecl1zI", "AinI", "Uba1337I", "Uba1186I", "Uba1119I", "SriI", "UbaHKBI", "Uba1213I", "Uba1212I", "Uba1211I", "Uba1328I", "Bsp107I", "Uba1215I", "Uba1216I", "Esp141I", "NasI", "PmyI", "PshEI", "Pae24I", "Pae25I", "Pae22I", "Ecl593I", "Pae26I", "Pfl37I", "Uba1287I", "BbiI", "ClcI", "Bsp108I", "MauI", "VchO87I", "Bsp81I", "BspS122I", "VpaK4AI", "VpaK4BI", "Pae14I", "Pae15I", "Uba1123I", "GseII", "Kpn12I", "SgiI", "Ecl699kI", "Ecl77I", "Uba1411I", "Srl32DI", "Bsp93I", "Uba1417I", "XorKII", "Esp5II", "Eco260I", "Eco261I", "Srl2DI", "Uba1262I", "Pae40I", "Pae41I", "YenDI", "YenEI", "YenBI", "YenCI", "Eco49I", "YenAI", "BscDI", "TspGWII", "Eco48I", "Msp11I", "VpaKutGI", "AspTI", "Pae39I", "BsaNII", "Srl1DI", "Uba1256I", "CauIII", "Sal13I", "Uba1149I", "Bsp78I", "Bce170I", "Pae9I", "Pae8I", "Uba72I", "Psp46I", "Uba71I", "BmeBI", "SprLI", "NgbI", "NocI", "XphI", "MizI"],
  site: "ctgcag",
  forwardRegex: "ctgcag",
  reverseRegex: "ctgcag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco32I", "HpyCI", "HjaI", "EcoRV", "CeqI", "NsiCI"],
  site: "gatatc",
  forwardRegex: "gatatc",
  reverseRegex: "gatatc",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BspBS31I", "BbsI", "Bbv16II", "BpiI", "BstV2I", "BspTS514I", "BspIS4I", "BstBS32I", "Bsc91I", "BbvII", "BstTS5I", "BpuAI"],
  isType2S: true,
  site: "gaagac",
  forwardRegex: "ga{2}gac",
  reverseRegex: "gtct{2}c",
  topSnipOffset: 8,
  bottomSnipOffset: 12
}, {
  aliases: ["BspJ64I", "HpyHPK5II", "Ssu212I", "Ssu211I", "R2.Ssu4109I", "TrsSI", "M.PhaTDam", "Uba1204I", "Bst1274I", "NlaDI", "TrsTI", "M.Kpn43816Dam", "UbaN1I", "CtyI", "Bth1997I", "Bth1786I", "AsuMBI", "Mel7JI", "Ssu220I", "NciAI", "BfiSHI", "M.EcoT2Dam", "SauCI", "M.Ssp6803Dam", "R1.Ssu11318I", "SalAI", "Bsp122I", "SauFI", "M.CjeEDam", "SauGI", "MspBI", "SauDI", "SauEI", "Uba59I", "SalHI", "Msp67II", "NmeAII", "Bth1140I", "BsmXII", "Bth1141I", "EsaLHCI", "SsuRBI", "NsuDI", "NgoDXIV", "Bsp91I", "Bsp61I", "Bsp60I", "R2.SsuDAT1I", "M.SmaII", "NsiAI", "Bsp65I", "Bsp135I", "Bsp64I", "R1.SsuDAT1I", "HpyAIII", "Mel5TI", "BthCanI", "Bsp138I", "Mel5OI", "Bsp136I", "Bsp66I", "FtnUIV", "BstEIII", "Bth211I", "Mel5JI", "SinMI", "M.HinHP1Dam", "M.EcoEc67Dam", "M.FspVDam", "CcoP31I", "R2.Ssu4961I", "Bth84I", "Cte1179I", "PfaI", "TruII", "Uba1259I", "Bsp72I", "Bsp74I", "Bsp147I", "FnuAII", "Bsp76I", "Cte1180I", "NflI", "CdiCD6II", "R1.Ssu4961I", "Mel4OI", "CcoP95II", "Sau6782I", "Bth221I", "Uba1366I", "Bth213I", "M.HindDam", "CpaPI", "Mmu5I", "Rlu1I", "Bme2494I", "BspI", "CviHI", "NanII", "MnoIII", "Sau15I", "Mel3JI", "R1.Ssu8074I", "M.YpsADam", "TdeI", "BsrMI", "Uba1317I", "Vha44I", "Bsp49I", "M.HinHP2Dam", "M.CviBII", "R1.Ssu2479I", "MthI", "BsrPII", "M.VvuDam", "Pph288I", "LlaDCHI", "Tsp133I", "Uba1183I", "Pei9403I", "Uba1182I", "SmiMBI", "M.StyDam", "M.TpaI", "M.PmuADam", "MjaIII", "Bth945I", "Mel2TI", "BsaPI", "BssGII", "M.NmaPhiCh1I", "BtcI", "Btu41I", "NmeBL859I", "Bsp58I", "Bsp59I", "M.CjeNIII", "Bsp57I", "Bsp54I", "MmeII", "Bsp52I", "M.PgiI", "Bsp51I", "Uba1177I", "NspAI", "NflBI", "Lsp1109II", "M.EcoT1Dam", "CcoP219I", "Mth1047I", "LlaKR2I", "Cin1467I", "CcoP76I", "Gst1588II", "M.EcoVT2Dam", "NmuEI", "R2.Ssu8074I", "MmuP2I", "Bsp18I", "NmuDI", "R1.Ssu4109I", "Btu34I", "R2.Ssu2479I", "Uba4I", "Btu33I", "MosI", "TrsKTI", "Btu39I", "Btu36I", "M.EcoT4Dam", "CjeP338I", "M.Sty14028Dam", "M.VchK139I", "Bsp9I", "Btu37I", "NsuI", "Uba1101I", "Csp5I", "R2.Ssu11318I", "M.EcoP1Dam", "M.StyLT2Dam", "CcoP84I", "Uba1323I", "MeuI", "M.EcoKDam", "BstXII", "CpfAI", "M.PmuDam", "Mph1103II", "NflAII", "MthAI"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SmaAIII", "EclJI", "Pvu84I", "Uba1129I", "XorKI", "DrdIII", "Uba1139I", "BmaDI", "BmaCI", "BmaBI", "Cfr51I", "RspI", "Xgl3220I", "Kpl79I", "Xgl3216I", "BmaI", "XniI", "Xgl3219I", "Xgl3218I", "Xgl3217I", "PntI", "BstZ8I", "BmaAI", "SplAIII", "SpaPII", "Cas2I", "XmlAI", "XmlI"],
  site: "cgatcg",
  forwardRegex: "cgatcg",
  reverseRegex: "cgatcg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BthII", "Bth617I", "BsrWI", "BpuFI", "Ral8I"],
  site: "ggatc",
  forwardRegex: "g{2}atc",
  reverseRegex: "gatc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BfuAI", "BspMI", "Acc36I", "BveI"],
  isType2S: true,
  site: "acctgc",
  forwardRegex: "ac{2}tgc",
  reverseRegex: "gcag{2}t",
  topSnipOffset: 10,
  bottomSnipOffset: 14
}, {
  aliases: ["Bst2BI", "BssSI", "BsiI", "BauI"],
  site: "cacgag",
  forwardRegex: "cacgag",
  reverseRegex: "ctcgtg",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["NmuFI", "Afa24RI", "ApeAI", "RluI", "SaoI", "AmeII", "NasWI", "AniMI", "NmuI", "Srl77DI", "Esp5I", "NspWI", "Smo40529I", "SkaI", "MisI", "PglI", "Mlu9273II", "NtaSII", "NbrI", "NbaI", "BheI", "Psp61I", "AprI", "SacAI", "MauAI", "SauAI", "SalCI", "Uba1122I"],
  site: "gccggc",
  forwardRegex: "gc{2}g{2}c",
  reverseRegex: "gc{2}g{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BthI", "DdeII", "PflNI", "BbiIII", "McaI", "ScuI", "PflWI", "Pfl67I", "Uba1237I", "Uba1397I", "SluI", "Uba1166I", "MecI", "Sca1827I", "Asp703I", "Uba1248I", "SdiAI", "Sfu1762I", "Msp23II", "AhyAI", "Psp4I", "Asp15I", "PspNI", "Ssp4I", "Uba1298I", "Uba1448I", "CjaI", "Uba1335I", "Sph1719I", "DrdDI", "SgoI", "MpuI", "Bsp92I", "Sve194I", "BadI", "Uba1271I", "MhaI", "SpaI", "Bsp129I", "SgaI", "AlwFII", "Shy1766I", "OcoI", "AerAI", "Uba1130I", "BbfI", "StaAI", "Asp47I", "Sgr1841I", "Bsp140I", "Bsp141I", "SrifpI", "Bsp142I", "MrhI", "BsuMI", "SciBI", "Uba1148I", "Sci1831I", "Eae2I", "MscAI", "Sal1974I", "Uba1154I", "SexI", "BstLI", "MsiI", "BstHI", "Bsp139I"],
  site: "ctcgag",
  forwardRegex: "ctcgag",
  reverseRegex: "ctcgag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Uba1382I", "Uba1415I"],
  site: "gaatgc",
  forwardRegex: "ga{2}tgc",
  reverseRegex: "gcat{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco97I", "Eco95I", "Bli161I", "Eco120I", "Eco127I", "Eco233I", "Eco185I", "Eco217I", "Eco225I", "Eco203I", "Eco156I", "Eco204I", "Eco155I", "Eco205I", "Eco157I", "PpaI", "Eco162I", "Uba1316I", "SlbI", "Eco129I", "Sau12I", "Eco51I", "Bli49I", "Bli5508I", "Cfr56I", "VpaKutHI", "Eco71KI", "Eco42I", "VpaK57AI", "Uba84I", "Rle69I", "Eco263I", "Eco101I", "VpaK57I", "Uba1343I", "Bli576II", "Eco191I", "Uba65I", "Eco239I", "Eco246I", "Eco247I", "Eco240I", "Eco241I"],
  site: "ggtctc",
  forwardRegex: "g{2}tctc",
  reverseRegex: "gagac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BmrI", "BfiI", "BmuI"],
  isType2S: true,
  site: "actggg",
  forwardRegex: "actg{3}",
  reverseRegex: "c{3}agt",
  topSnipOffset: 11,
  bottomSnipOffset: 10
}, {
  aliases: ["BstRZ246I", "MspSWI", "BstSWI", "SmiI", "SwaI"],
  site: "atttaaat",
  forwardRegex: "at{3}a{3}t",
  reverseRegex: "at{3}a{3}t",
  topSnipOffset: 4,
  bottomSnipOffset: 4
}, {
  aliases: ["Srl76DI", "Srl19I", "Srl61DI"],
  site: "tttaaa",
  forwardRegex: "t{3}a{3}",
  reverseRegex: "t{3}a{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Tsp32I", "Tsp32II", "TaqI", "PpaAII", "TthHB8I"],
  site: "tcga",
  forwardRegex: "tcga",
  reverseRegex: "tcga",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["EcoPI"],
  isType2S: true,
  site: "agacc",
  forwardRegex: "agac{2}",
  reverseRegex: "g{2}tct",
  topSnipOffset: 30,
  bottomSnipOffset: 32
}, {
  aliases: ["OmiBII", "DsaVI"],
  site: "gtmkac",
  forwardRegex: "gt[acm][gkt]ac",
  reverseRegex: "gt[acm][gkt]ac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BpuSI", "BspLU11III", "BstOZ616I", "BslFI", "FaqI", "BsmFI"],
  isType2S: true,
  site: "gggac",
  forwardRegex: "g{3}ac",
  reverseRegex: "gtc{3}",
  topSnipOffset: 15,
  bottomSnipOffset: 19
}, {
  aliases: ["BspJ105I", "VpaK13AI", "Uba1314I", "GspAI", "Uba1249I", "PolI", "VpaK7AI", "NspDII", "BceSII", "MliI", "VpaK11DI", "AspBII", "VpaK11I", "NspGI", "BtiI", "NspKI", "VpaK11CI", "Uba1304I", "Bsp1260I", "MfoI", "Uba48I", "UbaN15I", "NmuAII", "Uba1438I", "Bsp100I", "Tsp301I", "BspF53I", "Uba62I", "ClmII", "VpaK65I", "AspDII", "NspHII", "Sgh1835I", "Uba1131I", "CliI", "Asp697I", "Uba1413I", "Nli3877II", "Uba1278I", "Uba1272I", "Bsp128I", "NliII", "MspAI", "Bst4QI", "SfnI", "Uth554I", "Uba1373I", "Tru28I", "Pfl19I", "SinJI", "SinHI", "SinGI", "SinFI", "SinEI", "SinDI", "SinCI", "SinBI", "SinAI", "Bsp133I", "Bsp132I", "SynI", "TruI", "Hsp2I", "Bsp71I"],
  site: "ggwcc",
  forwardRegex: "g{2}[atw]c{2}",
  reverseRegex: "g{2}[atw]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NtaSI", "Uba1180I", "SsvI", "Uba1239I", "Uba1170I", "Ppu13I", "VchO44I", "ChyI", "GobAI", "Uba1217I", "PluI", "Uba40I", "Uba1419I", "Asp78I", "Uba1371I", "Uba1403I"],
  site: "aggcct",
  forwardRegex: "ag{2}c{2}t",
  reverseRegex: "ag{2}c{2}t",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BseGI", "BstF5I", "BtsCI"],
  site: "ggatg",
  forwardRegex: "g{2}atg",
  reverseRegex: "catc{2}",
  topSnipOffset: 7,
  bottomSnipOffset: 5,
  isType2S: true
}, {
  aliases: ["AvrII", "AspA2I", "XmaJI", "BlnI", "AvrBII", "BspA2I"],
  site: "cctagg",
  forwardRegex: "c{2}tag{2}",
  reverseRegex: "c{2}tag{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BspKT8I", "SsbI", "BspLAIII", "LlaCI", "BstFI", "HindIII", "HsuI", "BbrI", "EcoVIII"],
  site: "aagctt",
  forwardRegex: "a{2}gct{2}",
  reverseRegex: "a{2}gct{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["NsbI", "Acc16I", "PamI", "Pun14627I", "MstI", "AosI", "FspI", "AviII", "FdiII"],
  site: "tgcgca",
  forwardRegex: "tgcgca",
  reverseRegex: "tgcgca",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["Ecl136II", "BpuAmI", "MxaI", "Eco53kI", "EcoICRI"],
  site: "gagctc",
  forwardRegex: "gagctc",
  reverseRegex: "gagctc",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["TtmI", "TspWAM8AI", "HpyF74II", "HpyF35II", "TspIDSI", "HpyF13III"],
  site: "acgt",
  forwardRegex: "acgt",
  reverseRegex: "acgt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BseZI", "Ksp632I", "EarI", "Eam1104I", "Bsu6I", "Bst6I", "CatHI", "Bco116I", "Bco5I", "BcoKI"],
  isType2S: true,
  site: "ctcttc",
  forwardRegex: "ctct{2}c",
  reverseRegex: "ga{2}gag",
  topSnipOffset: 7,
  bottomSnipOffset: 10
}, {
  aliases: ["Msp24I", "BsaSI", "HpyF73IV", "MjaII", "VpaK15I", "TdeIII", "Sau557I", "Sau17I", "GseI", "Bfi105I", "Eco201I", "CfrNI", "Sau13I", "Sau14I", "Bse54I", "Eco196II", "VpaK25I", "Uba1164I", "NlaDII", "Cfr4I", "Cfr8I", "CdiCD6I", "AhaB1I", "MthBI", "Pph1579I", "Pph1773I", "Hin5II", "Sau32I", "VpaK9AI", "Sau33I", "Uba1099I", "NmuSI", "SauBI", "VchO85I", "Sau5I", "Cfr33I", "Eco39I", "Sau2I", "ApuI", "VchO90I", "PspI", "Uba1134I", "BpsI", "Cfr23I", "MhoI", "PseI", "Eco47II", "HpyF71II", "VpaK19AI", "VpaK19BI", "SdyI", "NmuEII", "Cfr52I", "Cfr54I", "NspLII", "VpaKutBI", "CdiAI", "VpaKutAI", "Bsu5044I", "HpyF66I", "SelAI", "Cfr46I", "Cfr47I", "Cfr45I", "Uba1160I", "VchO66I", "VpaKutJI"],
  site: "ggncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Cpa1150I", "PflAI", "TmaI", "BceRI", "FspMI", "MvaAI", "Uba1446I", "Bsu1193I", "EsaBS9I", "HpyF52II", "Bsu1192II", "HpyF14I", "HpyF15I", "Uba1321I", "HpyF64IV", "SceAI", "HpyF26I", "BspJ76I", "Bce31293I", "BsuEII", "Hin1056I", "Uba1405I", "Uba1404I", "Bsu6633I", "CpaAI", "Bsp70I"],
  site: "cgcg",
  forwardRegex: "cgcg",
  reverseRegex: "cgcg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TseI", "ApeKI", "AceI", "Taq52I", "SuiI"],
  site: "gcwgc",
  forwardRegex: "gc[atw]gc",
  reverseRegex: "gc[atw]gc",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["Asp27HI", "Asp26HI", "PctI", "Asp40HI", "BsaMI", "BscCI", "BsmI", "BmaHI", "Mva1269I", "Asp50HI", "Asp36HI", "Asp35HI"],
  site: "gaatgc",
  forwardRegex: "ga{2}tgc",
  reverseRegex: "gcat{2}c",
  topSnipOffset: 7,
  bottomSnipOffset: 5,
  isType2S: true
}, {
  aliases: ["Uba51I", "M.BamHII", "Uba1414I", "Uba1346I", "Bsu8646I", "AcaII", "SpvI", "BamNI", "GdoI", "UbaN3I", "BamKI", "Uba1205I", "BamFI", "BsuB519I", "Bst2902I", "Rlu4I", "Ali12257I", "Ali12258I", "Uba1250I", "RhsI", "Psp56I", "Uba1258I", "Bsp144I", "AinII", "Bco10278I", "Uba88I", "Uba1402I", "Bca1259I", "Bsp90II", "Bsp131I", "Bsp130I", "BstQI", "MleI", "Uba1383I", "Uba1302I", "GinI", "Uba19I", "Bst2464I", "Uba1167I", "GseIII", "Uba1163I", "BsaDI", "Pac1110I", "Bsp46I", "Uba1398I", "Uba1173I", "Uba1242I", "Uba1172I", "NasBI", "UbaN14I", "GoxI", "AaeI", "Uba31I", "DdsI", "Uba1324I", "Bsp30I", "Uba1325I", "AspTII", "Uba38I", "AacLI", "Pae177I", "Uba1098I", "BsuB763I", "Uba1339I", "Uba1297I", "Uba1334I", "Bst1126I", "Uba1224I", "Atu1II", "Bsu8565I", "Bsu90I"],
  site: "ggatcc",
  forwardRegex: "g{2}atc{2}",
  reverseRegex: "g{2}atc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SpaPIII", "PvuHKUI", "MziI", "SciAII", "SplAIV", "Sol3335I", "Bth2350I", "GspI", "Uba1245I", "Uba1227I", "SmaAIV", "Psp3I", "SbaI", "Psp5I"],
  site: "cagctg",
  forwardRegex: "cagctg",
  reverseRegex: "cagctg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BspZEI", "BscI", "Bsa29I", "PgaI", "BspOVII", "ClaI", "BseCI", "Bli41I", "BavCI", "BciBI", "LplI", "SpmI", "Ssp27144I", "ZhoI", "BspDI", "BanIII", "BsuTUI", "BshVI", "BspXI", "BstNZ169I", "Bsu15I", "BspJII", "AagI", "Bsp106I", "Bli86I", "BliAI", "Bst28I", "BbvAII", "BsiXI", "BcmI", "BliRI", "Bci29I", "LcaI", "Rme21I", "BdiI"],
  site: "atcgat",
  forwardRegex: "atcgat",
  reverseRegex: "atcgat",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["BspJ74I", "Bco35I", "Bth1795I", "Uba1444I", "Bsp22I", "Bsp28I", "Uba1437I"],
  site: "ctggag",
  forwardRegex: "ctg{2}ag",
  reverseRegex: "ctc{2}ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SolI", "Bsp98I", "Bce751I", "Uba4009I", "BamHI", "RspLKII", "SurI", "BstI", "OkrAI", "ApaCI", "Nsp29132II", "BspAAIII", "CelI", "AliI", "AsiI", "GstI", "Mlu23I", "NspSAIV", "Pfl8I", "BnaI", "AccEBI", "Bsp4009I"],
  site: "ggatcc",
  forwardRegex: "g{2}atc{2}",
  reverseRegex: "g{2}atc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["M.NgoHVIII", "NgoMVIII", "NgoJVIII", "NgoBVIII", "NgoDVIII"],
  site: "ggtga",
  forwardRegex: "g{2}tga",
  reverseRegex: "tcac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF13I", "HpyF1I", "HpyF4I", "HpyF6II", "HpyF9I", "HpyF31II", "HpyF49II", "HpyF51I", "HpyF34II", "HpyF48I", "HpyF62III", "HpyF40III", "HpyF25II", "Hpy99II", "Hpy8II", "HpyF35IV", "HpyF36I"],
  site: "gtsac",
  forwardRegex: "gt[cgs]ac",
  reverseRegex: "gt[cgs]ac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PsyI", "BgiI", "TelI", "Tth111I", "AspI", "PflFI", "AtsI"],
  site: "gacnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{3}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{3}gtc",
  topSnipOffset: 4,
  bottomSnipOffset: 5
}, {
  aliases: ["PfaAI", "AccB1I", "HgiHI", "HgiCI", "BspT107I", "MspB4I", "BanI", "BshNI", "Eco64I", "BbvBI"],
  site: "ggyrcc",
  forwardRegex: "g{2}[cty][agr]c{2}",
  reverseRegex: "g{2}[cty][agr]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BspMAI", "CflI", "Psp23I", "BspBI", "AliAJI", "Srl5DI", "MhaAI", "CfrA4I", "Ecl2zI", "AjoI", "Sag16I", "PstI", "Sag23I", "Ecl37kI", "Pfl21I", "ApiI", "Sst12I", "SalPI", "CstI", "YenI", "Bsp63I", "BloHII", "CfuII", "PaePI", "SflI", "HalII", "BsuBI", "Asp713I"],
  site: "ctgcag",
  forwardRegex: "ctgcag",
  reverseRegex: "ctgcag",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["SvoI", "PsuNI"],
  site: "crccggyg",
  forwardRegex: "c[agr]c{2}g{2}[cty]g",
  reverseRegex: "c[agr]c{2}g{2}[cty]g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SphI", "BbuI", "PaeI", "SpaHI", "RspLKI", "PfaAIII"],
  site: "gcatgc",
  forwardRegex: "gcatgc",
  reverseRegex: "gcatgc",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["PspN4I", "BspLI", "BmiI", "AspNI", "BscBI", "NlaIV"],
  site: "ggnncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]{2}c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]{2}c{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["HpyHPK5I", "HpyF32I", "HpyF34I", "HpyHI", "HpyF25I", "HpyF27I", "HpyF24II", "HpyF37I", "HpyF13II", "HpyF60II", "HpyF59I", "HpyF68II", "HpyF4II", "Bpa36II", "HpyF67I", "HpyF41II", "HpyF64V", "Bst295I", "BscPI", "HpyF70I", "HpyF5I", "HpyF7I", "HpyF66II", "HpyF6III", "HpyF72II", "HpyF30II", "HpyF11I", "HpyF19I", "HpyF22II", "HpyCH4II", "HpyF9II", "HpyF21I"],
  site: "ctnag",
  forwardRegex: "ct[abcdghkmnrstvwy]ag",
  reverseRegex: "ct[abcdghkmnrstvwy]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF51II", "HpyF74I", "HpyF42II", "HpyF35III", "HpyF9III", "HpyF64II", "HpyF20I", "HpyF22I", "HpyF12I", "HpyF41I", "HpyF40I", "HpyF46I", "HpyF56I", "HpyF58I", "HpyF55I", "HpyF54I", "HpyF5II", "HpyF48II", "HpyF69I", "HpyF68I", "HpyF65I", "HpyF62I"],
  site: "acngt",
  forwardRegex: "ac[abcdghkmnrstvwy]gt",
  reverseRegex: "ac[abcdghkmnrstvwy]gt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF15II", "HpyF17I", "HpyF64III", "HpyF50II", "HpyF61I", "HpyF11II", "HpyF27II", "HpyF12II", "HpyF46IV", "Hpy166I", "HpyF42III", "HpyF33I", "HpyF28I", "HpyF19II"],
  site: "tcnga",
  forwardRegex: "tc[abcdghkmnrstvwy]ga",
  reverseRegex: "tc[abcdghkmnrstvwy]ga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EclRI", "TspMI", "Pac25I", "XmaCI", "EaeAI", "AhyI", "XmaI", "Cfr9I", "PspAI", "XcyI"],
  site: "cccggg",
  forwardRegex: "c{3}g{3}",
  reverseRegex: "c{3}g{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["XapI", "CfaI", "FsiI", "ApoI", "AcsI"],
  site: "raatty",
  forwardRegex: "[agr]a{2}t{2}[cty]",
  reverseRegex: "[agr]a{2}t{2}[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["SenPI", "HpyNI", "Bsp548I", "LlaMI", "Eco51II", "Eco43I", "BsoI", "Bsp73I", "Eco200I", "Eco85I", "BsaCI", "Eco80I", "Uba17I", "Uba1391I", "Eco153I", "Bsp53I", "Eco93I"],
  site: "ccngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Tsp49I", "TaiI", "TscI"],
  site: "acgt",
  forwardRegex: "acgt",
  reverseRegex: "acgt",
  topSnipOffset: 4,
  bottomSnipOffset: 0
}, {
  aliases: ["DraII", "EcoO109I"],
  site: "rggnccy",
  forwardRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  reverseRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["Ssp34I", "AcaI", "Bsp151I", "Uba1452I", "Ssp48I", "Ssp47I", "BpuHI", "NspJI", "Uba1385I", "Rma376I", "NspFI", "Ssp45I", "NspBI", "Ssp42I", "Ssp43I", "Ssp14I", "Psc27I", "Psc28I", "BspH22I", "Afl83I", "Bsp101I", "Ssp152I", "Bsp102I", "Bsp104I", "Mva16I", "Bsp241I", "Rma523I", "Bsp82I", "Sgr1839I", "OspI", "Bsp90I", "AviI", "BspH106I", "BspH103I", "Bsp148I", "Nsp29132I"],
  site: "ttcgaa",
  forwardRegex: "t{2}cga{2}",
  reverseRegex: "t{2}cga{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CjuII"],
  site: "caynnnnnctc",
  forwardRegex: "ca[cty][abcdghkmnrstvwy]{5}ctc",
  reverseRegex: "gag[abcdghkmnrstvwy]{5}[agr]tg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaN6II", "BstNSII", "Bst7QI", "AspDI", "AspBI", "AvrI", "EspHK29I", "NspDI", "NspEI", "AcrI", "Uba1205II", "Gst1588I", "BstZ4I", "Uba1436I", "BstBAII", "Umi5I", "NliI", "NmuAI", "Uba1440I"],
  site: "cycgrg",
  forwardRegex: "c[cty]cg[agr]g",
  reverseRegex: "c[cty]cg[agr]g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AdeI", "DraIII", "BstIZ316I"],
  site: "cacnnngtg",
  forwardRegex: "cac[abcdghkmnrstvwy]{3}gtg",
  reverseRegex: "cac[abcdghkmnrstvwy]{3}gtg",
  topSnipOffset: 6,
  bottomSnipOffset: 3
}, {
  aliases: ["Uba153AI", "BavAI", "BavBI", "BspO4I", "BamGI", "BavI", "EclI", "Pvu84II", "BspM39I", "UbaM39I", "NmeRI", "PvuII", "DmaI", "Bsp153AI", "Pun14627II", "Cfr6I", "Pae17kI"],
  site: "cagctg",
  forwardRegex: "cagctg",
  reverseRegex: "cagctg",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["Ava458I", "Cfr38I", "Cfr39I", "KspHK15I", "Cfr40I", "EspHK24I", "Cfr55I", "EcoHAI", "Cfr59I", "Eco164I", "EspHK16I", "Uba1188I", "EciBI", "Eco90I", "Uba1327I", "Cfr14I", "Uba36I"],
  site: "yggccr",
  forwardRegex: "[cty]g{2}c{2}[agr]",
  reverseRegex: "[cty]g{2}c{2}[agr]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MchAI", "CspBI", "NotI", "CsiBI", "CciNI"],
  site: "gcggccgc",
  forwardRegex: "gcg{2}c{2}gc",
  reverseRegex: "gcg{2}c{2}gc",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["BscKI", "Rtr20I", "BspVI", "Bco102II", "BsaVI"],
  site: "gaagac",
  forwardRegex: "ga{2}gac",
  reverseRegex: "gtct{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AspMDI", "BfuCI", "NlaII", "HacI", "CcyI", "FnuEI", "FnuCI", "NdeII", "RalF40I", "BstMBI", "Sth368I", "SauMI", "Kzo9I", "MgoI", "MboI", "NphI", "Bsp67I", "BscFI", "LlaAI", "Bsp143I", "DpnII", "CviAI", "Bme12I", "PbrTI", "CpfI", "NmeCI", "SsiBI", "SsiAI", "Bfi57I", "Bst19II", "BstENII", "BssMI", "MkrAI", "BspAI", "BspFI", "BtkII", "BspJI", "CacI", "Bsp2095I", "BspKMI", "Sau3AI", "Bce243I", "Bsp105I"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 0,
  bottomSnipOffset: 4
}, {
  aliases: ["EcoprrI"],
  site: "ccannnnnnnrtgc",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{7}[agr]tgc",
  reverseRegex: "gca[cty][abcdghkmnrstvwy]{7}tg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Cfr48I", "Ese4I", "BscMI", "Uba1409I", "Eco262I", "Uba1159I", "Uba1264I", "Uba1263I", "Uba1363I", "Uba1142I", "Uba1357I", "Uba1421I", "Eco26I", "Eco25I", "Bsp117I", "Uba1206I", "Eco249I", "Eco35I", "Uba57I", "Uba1124I", "OmiAI", "OmiBI", "Eco113I", "Eco215I", "Eco216I", "Eco180I", "Uba1330I", "EcoT88I", "Uba1329I", "Ppu20I", "Eco232I", "Uba39I", "BstZ7I", "Uba1307I", "EcoT95I", "EcoT93I", "Eco68I", "Psp31I", "Eco211I"],
  site: "grgcyc",
  forwardRegex: "g[agr]gc[cty]c",
  reverseRegex: "g[agr]gc[cty]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PaeR7I", "PanI", "BluI", "BssHI", "TliI", "Sol10179I", "StrI", "SauLPII", "SlaI", "AbrI", "Sfr274I", "EscI", "Sbi68I", "Sau3239I", "MavI", "CcrI", "BspAAI", "MlaAI", "XpaI", "BstVI", "XhoI"],
  site: "ctcgag",
  forwardRegex: "ctcgag",
  reverseRegex: "ctcgag",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["MchI", "Mly113I", "NarI", "NunII", "SseAI", "NdaI"],
  site: "ggcgcc",
  forwardRegex: "g{2}cgc{2}",
  reverseRegex: "g{2}cgc{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["EgeI", "Eco78I", "DinI", "SfoI", "EheI"],
  site: "ggcgcc",
  forwardRegex: "g{2}cgc{2}",
  reverseRegex: "g{2}cgc{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["M.AtuCI", "HpyF72III", "HpyF38I", "HpyF44I", "HpyAIV", "M.BabI", "HpyF55II", "HpyF2II", "HpyIV", "NcaI", "NsiHI", "HpyF60I", "CviEI", "CviFI", "CviCI", "M.SmeI", "CviDI", "CviGI", "HpyF10II", "HpyF71III", "Hpy87AI", "HpyF18I", "NovII"],
  site: "gantc",
  forwardRegex: "ga[abcdghkmnrstvwy]tc",
  reverseRegex: "ga[abcdghkmnrstvwy]tc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bsp6I", "SatI", "Uur960I", "ItaI", "Fsp4HI", "Fnu4HI", "BisI", "FbrI", "GluI", "BsoFI"],
  site: "gcngc",
  forwardRegex: "gc[abcdghkmnrstvwy]gc",
  reverseRegex: "gc[abcdghkmnrstvwy]gc",
  topSnipOffset: 2,
  bottomSnipOffset: 3
}, {
  aliases: ["BsoDI", "Tsp504I", "TauII"],
  site: "cggccg",
  forwardRegex: "cg{2}c{2}g",
  reverseRegex: "cg{2}c{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Hpy178II", "TceI", "HpyAII", "HpyII"],
  site: "gaaga",
  forwardRegex: "ga{2}ga",
  reverseRegex: "tct{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PfeI", "TfiI"],
  site: "gawtc",
  forwardRegex: "ga[atw]tc",
  reverseRegex: "ga[atw]tc",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["NspIII", "BsoBI", "AvaI", "PunAI", "NspSAI", "BstSI", "BcoI", "BmeT110I", "PlaAI", "Bse15I", "OfoI", "AquI", "Eco88I", "BspLU4I", "Ama87I", "Eco27kI", "BsiHKCI"],
  site: "cycgrg",
  forwardRegex: "c[cty]cg[agr]g",
  reverseRegex: "c[cty]cg[agr]g",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["SdeAI"],
  site: "cagrag",
  forwardRegex: "cag[agr]ag",
  reverseRegex: "ct[cty]ctg",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["BcoDI", "BsoMAI", "BsmAI", "Alw26I", "BstMAI"],
  site: "gtctc",
  forwardRegex: "gtctc",
  reverseRegex: "gagac",
  topSnipOffset: 6,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["SauHI", "Uba1294I", "BseG73I", "Uba1184II", "PxyMZI", "AsuSAI", "SecIII", "Bli643I", "Eco76I", "Bst29I", "Eco110kI", "BstZ6I", "Eco118I", "Bst30I", "EciCI", "Eco115I", "Uba1333I", "Uba1332I"],
  site: "cctnagg",
  forwardRegex: "c{2}t[abcdghkmnrstvwy]ag{2}",
  reverseRegex: "c{2}t[abcdghkmnrstvwy]ag{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF44IV", "HpyCH4VI", "HpyF16II", "HpyF22III", "HpyF19III", "HpyNSH57II"],
  site: "tcnnga",
  forwardRegex: "tc[abcdghkmnrstvwy]{2}ga",
  reverseRegex: "tc[abcdghkmnrstvwy]{2}ga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["OtuI", "MarI", "OtuNI", "Uba1433I", "Uba1441I", "Mho2111I", "BsaLI", "OxaI"],
  site: "agct",
  forwardRegex: "agct",
  reverseRegex: "agct",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BfoI", "Bsp143II", "BstH2I", "AccB2I", "HaeII"],
  site: "rgcgcy",
  forwardRegex: "[agr]gcgc[cty]",
  reverseRegex: "[agr]gcgc[cty]",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco57I", "BspKT5I", "AcuI"],
  site: "ctgaag",
  forwardRegex: "ctga{2}g",
  reverseRegex: "ct{2}cag",
  topSnipOffset: 22,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["Uba1276I", "TdeII", "VpaO5I", "Bst158I", "UbaN7I", "BcrAI", "VpaKutEI", "VpaKutFI", "BsrEI", "Uba1192I", "BcoSI"],
  site: "ctcttc",
  forwardRegex: "ctct{2}c",
  reverseRegex: "ga{2}gag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SsoII", "StyD4I", "BstSCI", "Eco137kI", "Ecl18kI", "BstMZ611I", "Eco13kI", "BssKI", "DsaV", "Eco21kI", "Kpn2kI"],
  site: "ccngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["BsmXI", "BsmDI", "BsmCI"],
  site: "acnnnnnctcc",
  forwardRegex: "ac[abcdghkmnrstvwy]{5}ctc{2}",
  reverseRegex: "g{2}ag[abcdghkmnrstvwy]{5}gt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Uba1426I", "Uba1420I", "TrsTII", "Uba1374I", "BscLI", "Uba1266I", "VfiI", "BsaFI", "Uba1313I", "Uba1312I", "Uba1299I", "Uba1331I", "Uba1443I", "Cfr92I"],
  site: "cttaag",
  forwardRegex: "ct{2}a{2}g",
  reverseRegex: "ct{2}a{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcaI", "BstEII", "AspAI", "Eci125I", "BstT9I", "Bse64I", "AcrII", "BstPI", "BseT9I", "NspSAII", "BsiKI", "EcoO128I", "BstT10I", "Eco91I", "BseT10I", "EcoO65I", "PspEI"],
  site: "ggtnacc",
  forwardRegex: "g{2}t[abcdghkmnrstvwy]ac{2}",
  reverseRegex: "g{2}t[abcdghkmnrstvwy]ac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 6
}, {
  aliases: ["HpyAV", "Hin4II"],
  site: "ccttc",
  forwardRegex: "c{2}t{2}c",
  reverseRegex: "ga{2}g{2}",
  topSnipOffset: 11,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["BseII", "BsaKI", "Uba1408II", "MwhI"],
  site: "gttaac",
  forwardRegex: "gt{2}a{2}c",
  reverseRegex: "gt{2}a{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Sse8387I", "SdaI", "SbfI"],
  site: "cctgcagg",
  forwardRegex: "c{2}tgcag{2}",
  reverseRegex: "c{2}tgcag{2}",
  topSnipOffset: 6,
  bottomSnipOffset: 2
}, {
  aliases: ["SacII", "CscI", "SpuI", "PaeAI", "GceI", "SchZI", "SstII", "Cfr42I", "PaeQI", "Eae46I", "Pae14kI", "RaqI", "Mpr154I", "GalI", "NgoAIII", "GceGLI", "Eco29kI", "Sfr303I", "Pae5kI", "NgoPIII", "SenPT14bI", "SgrBI", "KspI", "SexBI", "SexCI", "Kpn378I"],
  site: "ccgcgg",
  forwardRegex: "c{2}gcg{2}",
  reverseRegex: "c{2}gcg{2}",
  topSnipOffset: 4,
  bottomSnipOffset: 2
}, {
  aliases: ["BpuNI", "FinI", "BscWI"],
  site: "gggac",
  forwardRegex: "g{3}ac",
  reverseRegex: "gtc{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Uba1431I", "SseI", "Umi7I", "Uba1447I", "PovI", "CpeI", "BceDI", "BmeTI", "Bco102I", "AtuSI", "M.TaeII", "Bst77I", "BstKI", "BstGI", "SstIV", "Uba1282I", "CthI", "Uba1283I", "BstZ10II"],
  site: "tgatca",
  forwardRegex: "tgatca",
  reverseRegex: "tgatca",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MaeIII"],
  site: "gtnac",
  forwardRegex: "gt[abcdghkmnrstvwy]ac",
  reverseRegex: "gt[abcdghkmnrstvwy]ac",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["Eco646I", "Eco1341I", "Eco1413I", "Eco1432I", "Eco1424I", "Eco1422I", "Eco1383I"],
  site: "ccannnnnnncttc",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{7}ct{2}c",
  reverseRegex: "ga{2}g[abcdghkmnrstvwy]{7}tg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MvaI", "Bst1I", "Bst2I", "BsiLI", "CthII", "Sth302I", "BshGI", "BspNI", "TaqXI", "Bse17I", "Bse16I", "Bst2UI", "Bse24I", "Bst38I", "SslI", "BciBII", "AglI", "BthDI", "BthEI", "ApyI", "ZanI", "CbrI", "BstM6I", "BptI", "AorI", "ApaORI", "BseBI", "Fsp1604I", "AeuI", "Sth117I", "SniI", "Bst100I", "BstOI", "BstNI"],
  site: "ccwgg",
  forwardRegex: "c{2}[atw]g{2}",
  reverseRegex: "c{2}[atw]g{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 3
}, {
  aliases: ["Bco27I", "CboI", "MspI", "BsuFI", "BsiSI", "Pde137I", "HpaII", "Sth134I", "Hin2I", "Bst40I", "HapII", "MnoI"],
  site: "ccgg",
  forwardRegex: "c{2}g{2}",
  reverseRegex: "c{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["Uba1368I", "Uba1156I", "Uba1157I", "Uba1202I", "EciEI", "Psp30I", "Uba1165I", "Uba1241I"],
  site: "gggccc",
  forwardRegex: "g{3}c{3}",
  reverseRegex: "g{3}c{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SduI", "BsoCI", "BspLS2I", "MhlI", "Bsp1286I", "BmyI", "NspII", "AocII"],
  site: "gdgchc",
  forwardRegex: "g[adgkrtw]gc[achmtwy]c",
  reverseRegex: "g[adgkrtw]gc[achmtwy]c",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["KspAI", "BstEZ359I", "BstHPI", "SsrI", "HpaI"],
  site: "gttaac",
  forwardRegex: "gt{2}a{2}c",
  reverseRegex: "gt{2}a{2}c",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["SfiI", "SdiI"],
  site: "ggccnnnnnggcc",
  forwardRegex: "g{2}c{2}[abcdghkmnrstvwy]{5}g{2}c{2}",
  reverseRegex: "g{2}c{2}[abcdghkmnrstvwy]{5}g{2}c{2}",
  topSnipOffset: 8,
  bottomSnipOffset: 5
}, {
  aliases: ["LlaG2I", "NheI", "PstNHI", "AsuNHI"],
  site: "gctagc",
  forwardRegex: "gctagc",
  reverseRegex: "gctagc",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["AluBI", "AluI", "MltI"],
  site: "agct",
  forwardRegex: "agct",
  reverseRegex: "agct",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["HpyF49V", "HpyF36III", "M.CviSI", "HpyF48III", "HpyJP26I", "HpyF38II", "HpyF45II", "HpyF67II", "Hpy26I"],
  site: "tgca",
  forwardRegex: "tgca",
  reverseRegex: "tgca",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["DraRI"],
  site: "caagnac",
  forwardRegex: "ca{2}g[abcdghkmnrstvwy]ac",
  reverseRegex: "gt[abcdghkmnrstvwy]ct{2}g",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["Eco1265I", "Eco1441I", "Eco1443I", "Eco1447I", "Eco1158I", "Eco14444I", "EcoBI"],
  site: "tgannnnnnnntgct",
  forwardRegex: "tga[abcdghkmnrstvwy]{8}tgct",
  reverseRegex: "agca[abcdghkmnrstvwy]{8}tca",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BbeAI", "PmnI", "McaAI", "NamI", "PatAI", "MsaI"],
  site: "ggcgcc",
  forwardRegex: "g{2}cgc{2}",
  reverseRegex: "g{2}cgc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BstC8I", "Cac8I"],
  site: "gcnngc",
  forwardRegex: "gc[abcdghkmnrstvwy]{2}gc",
  reverseRegex: "gc[abcdghkmnrstvwy]{2}gc",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["EsaBC3I"],
  site: "tcga",
  forwardRegex: "tcga",
  reverseRegex: "tcga",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["Pfr12I", "AmeI", "Bsp146I", "Uba1203I", "Pfl23I", "PliI", "AaqI", "DaqI", "ScoNI", "Uba1387I"],
  site: "gtgcac",
  forwardRegex: "gtgcac",
  reverseRegex: "gtgcac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AccIII", "PinBII", "CauB3I", "MroI", "Aor13HI", "BseAI", "Bsp13I", "Kpn2I", "PtaI", "BspEI", "Bsu23I", "BsiMI", "BlfI", "BbvAIII", "BspMII"],
  site: "tccgga",
  forwardRegex: "tc{2}g{2}a",
  reverseRegex: "tc{2}g{2}a",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Eco1342I", "Eco1344I", "EcoKI", "Eco1394I"],
  site: "aacnnnnnngtgc",
  forwardRegex: "a{2}c[abcdghkmnrstvwy]{6}gtgc",
  reverseRegex: "gcac[abcdghkmnrstvwy]{6}gt{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NgoJI", "NgoGI", "NgoMI", "HinHI", "NgoAI", "NgoBI", "M.NgoEI", "NgoCI", "NgoWI", "Bst16I", "Btu34II", "Bst1473II", "BsmHI"],
  site: "rgcgcy",
  forwardRegex: "[agr]gcgc[cty]",
  reverseRegex: "[agr]gcgc[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MboII", "NcuI"],
  site: "gaaga",
  forwardRegex: "ga{2}ga",
  reverseRegex: "tct{2}c",
  topSnipOffset: 13,
  bottomSnipOffset: 12,
  isType2S: true
}, {
  aliases: ["Eco188I", "Eco98I", "Uba1435I", "Hin5III", "Uba1219I", "UbaN17I", "SpaPIV", "Eco231I", "BstZ1II", "Csp231I", "Eco65I", "HinbIII", "ChuEI", "Asp52I", "Asp3065I", "Uba83I", "HinfII", "MkiI", "HinJCII", "BsmGII", "Hin1076III", "HinSAFI", "Hin173I", "Uba1164II", "BseHI", "BbrAI", "Bst170II", "BpeI", "Cfr32I"],
  site: "aagctt",
  forwardRegex: "a{2}gct{2}",
  reverseRegex: "a{2}gct{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["StsI"],
  site: "ggatg",
  forwardRegex: "g{2}atg",
  reverseRegex: "catc{2}",
  topSnipOffset: 15,
  bottomSnipOffset: 19,
  isType2S: true
}, {
  aliases: ["BstZ2I", "Uba1191I", "Uba1190I"],
  site: "gacnnnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{5}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{5}gtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Hin6I", "HinP1I", "HsoI", "HspAI", "SciNI", "BbtI"],
  site: "gcgc",
  forwardRegex: "gcgc",
  reverseRegex: "gcgc",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["PmdI"],
  site: "cctcagc",
  forwardRegex: "c{2}tcagc",
  reverseRegex: "gctgag{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BcefI"],
  site: "acggc",
  forwardRegex: "acg{2}c",
  reverseRegex: "gc{2}gt",
  topSnipOffset: 17,
  bottomSnipOffset: 18,
  isType2S: true
}, {
  aliases: ["Eco52I", "BstZI", "EagI", "XmaIII", "BseX3I", "EclXI", "AaaI", "SenPT16I"],
  site: "cggccg",
  forwardRegex: "cg{2}c{2}g",
  reverseRegex: "cg{2}c{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BsaJI", "SecI", "BssECI", "BseDI"],
  site: "ccnngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]{2}g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["CciI", "RspXI", "BspHI", "PagI", "RcaI"],
  site: "tcatga",
  forwardRegex: "tcatga",
  reverseRegex: "tcatga",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["FseI", "RigI"],
  site: "ggccggcc",
  forwardRegex: "g{2}c{2}g{2}c{2}",
  reverseRegex: "g{2}c{2}g{2}c{2}",
  topSnipOffset: 6,
  bottomSnipOffset: 2
}, {
  aliases: ["BstMWI", "HpyF10VI", "Bce4I", "BceCI", "BspWI", "MwoI"],
  site: "gcnnnnnnngc",
  forwardRegex: "gc[abcdghkmnrstvwy]{7}gc",
  reverseRegex: "gc[abcdghkmnrstvwy]{7}gc",
  topSnipOffset: 7,
  bottomSnipOffset: 4
}, {
  aliases: ["HpyF10III", "Uba1442I", "HpyF67IV", "BstZ10I", "BsoKI", "HpyF61II", "Hpy99IV"],
  site: "ccnngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]{2}g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Aor51HI", "FunI", "Eco47III", "AitI", "AfeI"],
  site: "agcgct",
  forwardRegex: "agcgct",
  reverseRegex: "agcgct",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["MlyI", "SchI"],
  site: "gagtc",
  forwardRegex: "gagtc",
  reverseRegex: "gactc",
  topSnipOffset: 10,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["BseB631I", "VanI", "Bpu86I", "Tsp219I", "BsoJI"],
  site: "gccnnnnnggc",
  forwardRegex: "gc{2}[abcdghkmnrstvwy]{5}g{2}c",
  reverseRegex: "gc{2}[abcdghkmnrstvwy]{5}g{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bsp120I", "PspOMI"],
  site: "gggccc",
  forwardRegex: "g{3}c{3}",
  reverseRegex: "g{3}c{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Csp6I", "RsaNI", "CviRII", "CviQI"],
  site: "gtac",
  forwardRegex: "gtac",
  reverseRegex: "gtac",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["M.Phi3TI", "Cac824I", "Bpu1811I", "M.NgoBXII", "M.Rho11sI", "CcoP216I", "CcoP215I", "Bli1904II", "BssFI", "BssXI", "M.SPBetaI", "LlaDII"],
  site: "gcngc",
  forwardRegex: "gc[abcdghkmnrstvwy]gc",
  reverseRegex: "gc[abcdghkmnrstvwy]gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AflII", "MspCI", "Vha464I", "Bst98I", "BstAFI", "Esp4I", "BstPZ740I", "BfrI", "BspTI"],
  site: "cttaag",
  forwardRegex: "ct{2}a{2}g",
  reverseRegex: "ct{2}a{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BthCI"],
  site: "gcngc",
  forwardRegex: "gc[abcdghkmnrstvwy]gc",
  reverseRegex: "gc[abcdghkmnrstvwy]gc",
  topSnipOffset: 4,
  bottomSnipOffset: 1
}, {
  aliases: ["TfiTok6A1I", "TspAK13D21I", "TspVil3I", "M.Rho11sII", "Hpy26II", "HpyF65II", "TflI", "HpyF16I", "TfiTok4A2I", "HpyF23I", "HpyV", "Tsp358I", "HpyF71I", "HpyF73II", "TfiA3I", "HpyF26III", "TspAK16D24I", "Tsc4aI", "HpyF42IV", "HpyF66IV", "TspVi4AI", "M.CviBIII", "TthRQI", "Tbr51I", "HpyF52I", "HpyF49I", "Tth24I", "M.Phi3TII", "HpyF64I", "CviSIII", "HpyF40II", "Taq20I", "Tsp505I", "HpyF35I", "HpyF62II", "HpyJP26II", "HpyF30I", "HpyF24I", "HpyF59III", "TspNI", "Tsp510I", "HpyF45I", "HpyF14III"],
  site: "tcga",
  forwardRegex: "tcga",
  reverseRegex: "tcga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SthNI", "SthBI", "SthCI", "SthDI", "SthEI", "SthAI", "SthJI", "SthKI", "SthLI", "SthMI", "SthFI", "SthGI", "SthHI", "Uba1201I", "Uba76I", "Uba86I", "Uba85I", "Uba87I", "NmiI", "KpnK14I", "Eco149I", "MvsAI", "MvsDI", "MvsEI", "MvsBI", "MvsCI", "BspJ106I", "Sau10I", "Esp19I", "MvsI"],
  site: "ggtacc",
  forwardRegex: "g{2}tac{2}",
  reverseRegex: "g{2}tac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["M.NgoBIX"],
  site: "gtannnnnctc",
  forwardRegex: "gta[abcdghkmnrstvwy]{5}ctc",
  reverseRegex: "gag[abcdghkmnrstvwy]{5}tac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Asp29HI", "HpyF65III", "HpyF21II", "HpyF59II", "Hpy303I", "HpyF10IV", "HpyF66III", "Hpy471I", "Hpy423I", "Hpy421I", "HpyHII", "Asp18HI", "CcoP73I", "HpyNSH57I", "Hpy312I", "HpyF53II", "Asp17HI", "HpyF44V", "Hpy401I", "HpyF13IV", "HpyF31I", "HpyF36II", "Asp16HI", "HpyF52III", "Hpy501I", "MjaV"],
  site: "gtac",
  forwardRegex: "gtac",
  reverseRegex: "gtac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bsp19I", "NcoI"],
  site: "ccatgg",
  forwardRegex: "c{2}atg{2}",
  reverseRegex: "c{2}atg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Psp1406I", "AclI"],
  site: "aacgtt",
  forwardRegex: "a{2}cgt{2}",
  reverseRegex: "a{2}cgt{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["Uba1432I", "Asp17I", "Asp8HI", "AitII", "AitAI", "BpuGI", "Asp21HI", "Asp22I", "Asp1HI", "Asp14HI", "BscSI", "Asp6HI"],
  site: "rgatcy",
  forwardRegex: "[agr]gatc[cty]",
  reverseRegex: "[agr]gatc[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["RpaB5I"],
  site: "cgrggac",
  forwardRegex: "cg[agr]g{2}ac",
  reverseRegex: "gtc{2}[cty]cg",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["LweI", "SfaNI", "BspST5I", "BmsI", "PhaI"],
  site: "gcatc",
  forwardRegex: "gcatc",
  reverseRegex: "gatgc",
  topSnipOffset: 10,
  bottomSnipOffset: 14,
  isType2S: true
}, {
  aliases: ["EcoA4I", "BspTNI", "EcoO44I", "Bso31I", "BsaI", "Eco31I", "Bli736I"],
  isType2S: true,
  site: "ggtctc",
  forwardRegex: "g{2}tctc",
  reverseRegex: "gagac{2}",
  topSnipOffset: 7,
  bottomSnipOffset: 11
}, {
  aliases: ["Asi256I"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["Uba1362I", "TseAI", "Bka1125I", "HpyF36IV", "HpyF47I", "Mlu40I", "BstZ15I"],
  site: "gdgchc",
  forwardRegex: "g[adgkrtw]gc[achmtwy]c",
  reverseRegex: "g[adgkrtw]gc[achmtwy]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Ppu21I", "BsaAI", "PsuAI", "BstBAI", "MspYI"],
  site: "yacgtr",
  forwardRegex: "[cty]acgt[agr]",
  reverseRegex: "[cty]acgt[agr]",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["Vsp2246I", "Eco50I", "Uba1127I", "Eco195I", "Bme05I", "Eco173I", "SspM1III", "Eco171I", "Esp25I", "Esp22I", "Esp21I", "Esp15I", "Esp9I", "Esp14I", "Esp13I", "Esp12I", "Esp11I", "Esp10I", "Esp1I", "Esp6I", "Pph14I", "Eco169I", "Eco168I"],
  site: "ggyrcc",
  forwardRegex: "g{2}[cty][agr]c{2}",
  reverseRegex: "g{2}[cty][agr]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Mlu1106I"],
  site: "rggwccy",
  forwardRegex: "[agr]g{2}[atw]c{2}[cty]",
  reverseRegex: "[agr]g{2}[atw]c{2}[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bst22I", "BsiYI", "BflI", "Bsc107I", "BseLI", "AfiI", "BslI", "Bsc4I"],
  site: "ccnnnnnnngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]{7}g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]{7}g{2}",
  topSnipOffset: 7,
  bottomSnipOffset: 4
}, {
  aliases: ["BstD102I", "BsrBI", "MbiI", "AccBSI", "Bst31NI"],
  site: "ccgctc",
  forwardRegex: "c{2}gctc",
  reverseRegex: "gagcg{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BsrXI", "Msp23I", "BspLU11II"],
  site: "tctaga",
  forwardRegex: "tctaga",
  reverseRegex: "tctaga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AclNI", "BcuI", "SpeI", "AhlI"],
  site: "actagt",
  forwardRegex: "actagt",
  reverseRegex: "actagt",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["PunAII", "AvoI", "PauAI", "NspHI", "BstNSI", "NspI", "XceI"],
  site: "rcatgy",
  forwardRegex: "[agr]catg[cty]",
  reverseRegex: "[agr]catg[cty]",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["MscI", "BalI", "MluNI", "MlsI", "Mlu31I", "Msp20I"],
  site: "tggcca",
  forwardRegex: "tg{2}c{2}a",
  reverseRegex: "tg{2}c{2}a",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BmgI"],
  site: "gkgccc",
  forwardRegex: "g[gkt]gc{3}",
  reverseRegex: "g{3}c[acm]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BglII", "NcrI", "Pae2kI", "Pae18kI", "NspMACI"],
  site: "agatct",
  forwardRegex: "agatct",
  reverseRegex: "agatct",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["FatII", "M.CviSII", "Hin8II"],
  site: "catg",
  forwardRegex: "catg",
  reverseRegex: "catg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CglI", "NgoFVII"],
  site: "gcsgc",
  forwardRegex: "gc[cgs]gc",
  reverseRegex: "gc[cgs]gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SspM1II", "NlaSII", "SspJII", "Uba1381I", "Hin8I", "SspM2II"],
  site: "grcgyc",
  forwardRegex: "g[agr]cg[cty]c",
  reverseRegex: "g[agr]cg[cty]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["VchO68I", "BscOI", "PaeCI", "Asp5HI", "Bsp121I", "Uba1226I", "Uba1162I", "CglAI", "BtgAII", "SpaXI"],
  site: "gcatgc",
  forwardRegex: "gcatgc",
  reverseRegex: "gcatgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["XcaI", "BstZ17I", "BspM90I", "BssNAI", "BstBSI", "Bst1107I"],
  site: "gtatac",
  forwardRegex: "gtatac",
  reverseRegex: "gtatac",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["Bme1580I", "BstSLI", "BseSI", "BaeGI"],
  site: "gkgcmc",
  forwardRegex: "g[gkt]gc[acm]c",
  reverseRegex: "g[gkt]gc[acm]c",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["MthFI", "Rma500I", "Rma501I", "Rma503I", "FisI", "Rma509I", "Rma506I", "Rma510I", "MjaI", "Rma515I", "Rma516I", "Rma517I", "Rma518I", "Rma519I", "Rma496I", "Rma495I", "Rma522I", "Rma497I", "UbaN5I", "Rma490I", "Rma486I", "Rma485I"],
  site: "ctag",
  forwardRegex: "ctag",
  reverseRegex: "ctag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SelI"],
  site: "cgcg",
  forwardRegex: "cgcg",
  reverseRegex: "cgcg",
  topSnipOffset: 0,
  bottomSnipOffset: 4
}, {
  aliases: ["Mlu9273I", "VchO70I", "Sna3286I", "SalDI", "PspDI", "Uba1117I", "Uba1386I", "AmaSI"],
  site: "tcgcga",
  forwardRegex: "tcgcga",
  reverseRegex: "tcgcga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Hsp92I", "BbiII", "Msp17I", "HgiGI", "HgiDI", "AsuIII", "PamII", "BsaHI", "BstACI", "HgiHII", "AcyI", "BssNI", "Hin1I", "AhaII", "AstWI", "HgiI", "AosII"],
  site: "grcgyc",
  forwardRegex: "g[agr]cg[cty]c",
  reverseRegex: "g[agr]cg[cty]c",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["BtgZI"],
  site: "gcgatg",
  forwardRegex: "gcgatg",
  reverseRegex: "catcgc",
  topSnipOffset: 16,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["Bme142I", "LpnI"],
  site: "rgcgcy",
  forwardRegex: "[agr]gcgc[cty]",
  reverseRegex: "[agr]gcgc[cty]",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["PlaAII", "HpyBI", "RsaI", "AfaI"],
  site: "gtac",
  forwardRegex: "gtac",
  reverseRegex: "gtac",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["Tru201I", "BloHI", "BstX2I", "MflI", "BstYI", "XhoII", "PsuI", "DsaIII"],
  site: "rgatcy",
  forwardRegex: "[agr]gatc[cty]",
  reverseRegex: "[agr]gatc[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Eco252I", "Uba58I", "Van91II", "VchO2I", "Eco159I", "Hal22I", "Eco82I", "Eco228I", "Eco237I", "VchN100I"],
  site: "gaattc",
  forwardRegex: "ga{2}t{2}c",
  reverseRegex: "ga{2}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MluB2I", "Bsp68I", "RruI", "SpoI", "NruI", "BtuMI", "Sbo13I"],
  site: "tcgcga",
  forwardRegex: "tcgcga",
  reverseRegex: "tcgcga",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["AlwXI", "Bst12I", "BseKI", "BbvI", "Bst71I", "BseXI", "BstV1I", "Bsp423I", "Lsp1109I"],
  site: "gcagc",
  forwardRegex: "gcagc",
  reverseRegex: "gctgc",
  topSnipOffset: 13,
  bottomSnipOffset: 17,
  isType2S: true
}, {
  aliases: ["BspACI", "SsiI", "AciI"],
  site: "ccgc",
  forwardRegex: "c{2}gc",
  reverseRegex: "gcg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["EcoT38I", "PaeHI", "KoxII", "SacNI", "Eco24I", "BpuI", "FriOI", "Bsu1854I", "Eco75KI", "BanII", "BvuI", "HgiJII", "Bsp519I"],
  site: "grgcyc",
  forwardRegex: "g[agr]gc[cty]c",
  reverseRegex: "g[agr]gc[cty]c",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["PasI"],
  site: "cccwggg",
  forwardRegex: "c{3}[atw]g{3}",
  reverseRegex: "c{3}[atw]g{3}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["MluCI", "TseCI"],
  site: "aatt",
  forwardRegex: "a{2}t{2}",
  reverseRegex: "a{2}t{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF50I", "HpyF49III", "HpyF14II", "HpyF7III", "HpyF46III", "MjaIV"],
  site: "gtnnac",
  forwardRegex: "gt[abcdghkmnrstvwy]{2}ac",
  reverseRegex: "gt[abcdghkmnrstvwy]{2}ac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Psp1009I", "Tsp8EI", "BglI"],
  site: "gccnnnnnggc",
  forwardRegex: "gc{2}[abcdghkmnrstvwy]{5}g{2}c",
  reverseRegex: "gc{2}[abcdghkmnrstvwy]{5}g{2}c",
  topSnipOffset: 7,
  bottomSnipOffset: 4
}, {
  aliases: ["SruI", "DraI", "PauAII", "AhaIII"],
  site: "tttaaa",
  forwardRegex: "t{3}a{3}",
  reverseRegex: "t{3}a{3}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["AccI", "XmiI", "FblI"],
  site: "gtmkac",
  forwardRegex: "gt[acm][gkt]ac",
  reverseRegex: "gt[acm][gkt]ac",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["PmeI", "MssI"],
  site: "gtttaaac",
  forwardRegex: "gt{3}a{3}c",
  reverseRegex: "gt{3}a{3}c",
  topSnipOffset: 4,
  bottomSnipOffset: 4
}, {
  aliases: ["PshDI", "PshCI", "PspBI", "Pgl34I", "Psp38I", "VpaK3AI", "VpaK3BI", "Bsp87I"],
  site: "cacgtg",
  forwardRegex: "cacgtg",
  reverseRegex: "cacgtg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AxyI", "AocI", "Lmu60I", "BspR7I", "OxaNI", "CvnI", "MstII", "Bsu36I", "Eco81I", "SshAI", "SauI", "BliHKI", "Bse21I"],
  site: "cctnagg",
  forwardRegex: "c{2}t[abcdghkmnrstvwy]ag{2}",
  reverseRegex: "c{2}t[abcdghkmnrstvwy]ag{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["TsoI"],
  site: "tarcca",
  forwardRegex: "ta[agr]c{2}a",
  reverseRegex: "tg{2}[cty]ta",
  topSnipOffset: 17,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["PlaII", "LspI", "SspRFI", "BsiCI", "Bpu14I", "AcpI", "FspII", "MlaI", "AsuII", "Ssp1I", "Asp10HI", "NspV", "Bsp119I", "BspLAII", "SviI", "PpaAI", "SfuI", "CbiI", "Bim19I", "BstBI", "BimI", "Csp68KII", "Csp45I", "BspT104I"],
  site: "ttcgaa",
  forwardRegex: "t{2}cga{2}",
  reverseRegex: "t{2}cga{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["EspHK26I", "Bla7920I", "Uba1375I", "BspH226I", "Cfr57I", "Tsp514I", "Bsp233I", "Uba1136I", "Uba1425I", "Tsp507I", "Bsp228I", "Uba1279I", "Bbf7411I", "BstZ3I", "Bsu22I", "BstZ1I", "BsiGI", "BsiOI", "Bsp508I"],
  site: "tccgga",
  forwardRegex: "tc{2}g{2}a",
  reverseRegex: "tc{2}g{2}a",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BpuEI", "Bce83I"],
  site: "cttgag",
  forwardRegex: "ct{2}gag",
  reverseRegex: "ctca{2}g",
  topSnipOffset: 22,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["AspS9I", "AsuI", "NspIV", "BsiZI", "Bsp1894I", "BspF4I", "Cfr13I", "BshKI", "BspBII", "Pde12I", "PspPI", "MaeK81II", "BavAII", "Nsp7121I", "BavBII", "Bal228I", "CcuI", "Sau96I", "AvcI", "Bsu54I", "Bce22I", "Bac36I"],
  site: "ggncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["BstKTI", "BspKT6I"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 3,
  bottomSnipOffset: 1
}, {
  aliases: ["BfmI", "BdiSI", "Srl56DI", "BpcI", "BthP35I", "SfcI", "BstSFI", "LlaBI", "SfeI"],
  site: "ctryag",
  forwardRegex: "ct[agr][cty]ag",
  reverseRegex: "ct[agr][cty]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["MseI", "Tru1I", "Tru9I", "SaqAI"],
  site: "ttaa",
  forwardRegex: "t{2}a{2}",
  reverseRegex: "t{2}a{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["Sau96mI", "Sau93I", "Sau98I", "Sau90I"],
  site: "ctyrag",
  forwardRegex: "ct[cty][agr]ag",
  reverseRegex: "ct[cty][agr]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TrsSII"],
  site: "gacnnnnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{6}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{6}gtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["ParI", "BsiQI", "BclI", "AbaI", "FbaI", "Ksp22I", "BstT7I", "BspXII"],
  site: "tgatca",
  forwardRegex: "tgatca",
  reverseRegex: "tgatca",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Eco255I", "DpaI", "BmcAI", "ZrmI", "ScaI", "AssI", "Bpa34I", "Acc113I", "RflFII"],
  site: "agtact",
  forwardRegex: "agtact",
  reverseRegex: "agtact",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["SplAII", "TteI", "TspI", "TrsKTII", "FsuI", "SmaAII", "NtaI", "SplII", "SpaPI", "TtrI"],
  site: "gacnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{3}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{3}gtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AspLEI", "HhaI", "BspLAI", "CfoI", "BstHHI", "FnuDIII"],
  site: "gcgc",
  forwardRegex: "gcgc",
  reverseRegex: "gcgc",
  topSnipOffset: 3,
  bottomSnipOffset: 1
}, {
  aliases: ["StyLTI"],
  site: "cagag",
  forwardRegex: "cagag",
  reverseRegex: "ctctg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BsoEI", "Uba1289I", "Uba1290I", "BstWI", "Uba1309I", "Uba1308I", "Uba1310I", "Bpu1268I"],
  site: "cctnnnnnagg",
  forwardRegex: "c{2}t[abcdghkmnrstvwy]{5}ag{2}",
  reverseRegex: "c{2}t[abcdghkmnrstvwy]{5}ag{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco826I", "Eco1455I"],
  site: "gcannnnnnctga",
  forwardRegex: "gca[abcdghkmnrstvwy]{6}ctga",
  reverseRegex: "tcag[abcdghkmnrstvwy]{6}tgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["ApaI", "PpeI"],
  site: "gggccc",
  forwardRegex: "g{3}c{3}",
  reverseRegex: "g{3}c{3}",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["KpnBI"],
  site: "caaannnnnnrtca",
  forwardRegex: "ca{3}[abcdghkmnrstvwy]{6}[agr]tca",
  reverseRegex: "tga[cty][abcdghkmnrstvwy]{6}t{3}g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UnbI"],
  site: "ggncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["Uba1384I", "SmuCI", "AvaIII", "Uba1353I", "PxyJKI", "Uba1367I", "BfrCI", "SrlII"],
  site: "atgcat",
  forwardRegex: "atgcat",
  reverseRegex: "atgcat",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BspMKI", "XciI", "SalI", "HgiCIII", "Rtr63I", "Rrh4273I", "RflFI", "HgiDII", "NopI", "RtrI"],
  site: "gtcgac",
  forwardRegex: "gtcgac",
  reverseRegex: "gtcgac",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["EcoR124I"],
  site: "gaannnnnnrtcg",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{6}[agr]tcg",
  reverseRegex: "cga[cty][abcdghkmnrstvwy]{6}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SynII", "Psc2I"],
  site: "gaannnnttc",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{4}t{2}c",
  reverseRegex: "ga{2}[abcdghkmnrstvwy]{4}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CspI", "Rsr2I", "RsrII", "CpoI"],
  site: "cggwccg",
  forwardRegex: "cg{2}[atw]c{2}g",
  reverseRegex: "cg{2}[atw]c{2}g",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["AscI", "PalAI", "SgsI"],
  site: "ggcgcgcc",
  forwardRegex: "g{2}cgcgc{2}",
  reverseRegex: "g{2}cgcgc{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["Uba69I", "TtmII", "BscEI", "BsrHI", "Kpn30I", "M.BssHIII", "BssBI", "Eco143I", "Eco152I", "Esp7I", "Esp8I", "CfrJ5I", "BsoPI"],
  site: "gcgcgc",
  forwardRegex: "gcgcgc",
  reverseRegex: "gcgcgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EclHKI", "BspOVI", "AhdI", "AspEI", "Eam1105I", "NruGI", "BmeRI", "DriI"],
  site: "gacnnnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{5}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{5}gtc",
  topSnipOffset: 6,
  bottomSnipOffset: 5
}, {
  aliases: ["Uba1222I", "Uba1221I", "BpuGCI", "Uba1320I", "Uba1284I"],
  site: "gctnagc",
  forwardRegex: "gct[abcdghkmnrstvwy]agc",
  reverseRegex: "gct[abcdghkmnrstvwy]agc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BpuCI"],
  site: "ggcgga",
  forwardRegex: "g{2}cg{2}a",
  reverseRegex: "tc{2}gc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EspI", "BlpI", "Bsp1720I", "Bpu1102I", "CelII"],
  site: "gctnagc",
  forwardRegex: "gct[abcdghkmnrstvwy]agc",
  reverseRegex: "gct[abcdghkmnrstvwy]agc",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["Eco1476I", "Eco1427I", "Eco1430I", "Eco1323I", "Eco377I", "Eco1386I", "Eco37I", "Eco1344II", "Eco1456I"],
  site: "ggannnnnnnnatgc",
  forwardRegex: "g{2}a[abcdghkmnrstvwy]{8}atgc",
  reverseRegex: "gcat[abcdghkmnrstvwy]{8}tc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MnnI", "Hin1160II", "ChuEII", "Hin1161II"],
  site: "gtyrac",
  forwardRegex: "gt[cty][agr]ac",
  reverseRegex: "gt[cty][agr]ac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SstI", "SacI", "Psp124BI"],
  site: "gagctc",
  forwardRegex: "gagctc",
  reverseRegex: "gagctc",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["SspD5II", "NsiI", "PinBI", "Asi372I", "Mph1103I", "Csp68KIII", "Zsp2I", "SepI", "EcoT22I", "BfrBI"],
  site: "atgcat",
  forwardRegex: "atgcat",
  reverseRegex: "atgcat",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["AsnI", "AseI", "VspI", "PshBI", "Sru4DI", "BpoAI"],
  site: "attaat",
  forwardRegex: "at{2}a{2}t",
  reverseRegex: "at{2}a{2}t",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["BmrFI", "Msp67I", "MspR9I", "ScrFI", "Bme1390I"],
  site: "ccngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]g{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 3
}, {
  aliases: ["McrI", "BsaOI", "BsiEI", "Bsh1285I", "BstMCI"],
  site: "cgrycg",
  forwardRegex: "cg[agr][cty]cg",
  reverseRegex: "cg[agr][cty]cg",
  topSnipOffset: 4,
  bottomSnipOffset: 2
}, {
  aliases: ["TspRI", "TscAI"],
  site: "castgnn",
  forwardRegex: "ca[cgs]tg[abcdghkmnrstvwy]{2}",
  reverseRegex: "[abcdghkmnrstvwy]{2}ca[cgs]tg",
  topSnipOffset: 7,
  bottomSnipOffset: 0
}, {
  aliases: ["BsmWI", "SmaAI", "SspKI", "SplAI", "PfuNI"],
  site: "cgtacg",
  forwardRegex: "cgtacg",
  reverseRegex: "cgtacg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CdiI"],
  site: "catcg",
  forwardRegex: "catcg",
  reverseRegex: "cgatg",
  topSnipOffset: 4,
  bottomSnipOffset: 4
}, {
  aliases: ["TrsKTIII"],
  site: "catatg",
  forwardRegex: "catatg",
  reverseRegex: "catatg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BseB631II"],
  site: "agatct",
  forwardRegex: "agatct",
  reverseRegex: "agatct",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Sth302II"],
  site: "ccgg",
  forwardRegex: "c{2}g{2}",
  reverseRegex: "c{2}g{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["PbuJKI", "Hpy178VI", "HpyF67III", "HinGUII", "HpyF6I"],
  site: "ggatg",
  forwardRegex: "g{2}atg",
  reverseRegex: "catc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaF13I"],
  site: "gagnnnnnnctgg",
  forwardRegex: "gag[abcdghkmnrstvwy]{6}ctg{2}",
  reverseRegex: "c{2}ag[abcdghkmnrstvwy]{6}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MreI", "Sse232I"],
  site: "cgccggcg",
  forwardRegex: "cgc{2}g{2}cg",
  reverseRegex: "cgc{2}g{2}cg",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["BsaGI", "HpyF7II", "Pph3215I", "Bfu1570I", "BsmPI", "HpyF46II", "Hpy8III"],
  site: "gwgcwc",
  forwardRegex: "g[atw]gc[atw]c",
  reverseRegex: "g[atw]gc[atw]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BceSIII", "BceAI"],
  site: "acggc",
  forwardRegex: "acg{2}c",
  reverseRegex: "gc{2}gt",
  topSnipOffset: 17,
  bottomSnipOffset: 19,
  isType2S: true
}, {
  aliases: ["CstMI"],
  site: "aaggag",
  forwardRegex: "a{2}g{2}ag",
  reverseRegex: "ctc{2}t{2}",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["Acc65I", "Asp718I", "SthI", "AhaB8I"],
  site: "ggtacc",
  forwardRegex: "g{2}tac{2}",
  reverseRegex: "g{2}tac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["EacI", "BinI", "AlwI", "Bst31TI", "BspPI", "AclWI", "BstH9I"],
  site: "ggatc",
  forwardRegex: "g{2}atc",
  reverseRegex: "gatc{2}",
  topSnipOffset: 9,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["BspGI"],
  site: "ctggac",
  forwardRegex: "ctg{2}ac",
  reverseRegex: "gtc{2}ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BspCNI"],
  site: "ctcag",
  forwardRegex: "ctcag",
  reverseRegex: "ctgag",
  topSnipOffset: 14,
  bottomSnipOffset: 12,
  isType2S: true
}, {
  aliases: ["MunI", "MfeI"],
  site: "caattg",
  forwardRegex: "ca{2}t{2}g",
  reverseRegex: "ca{2}t{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["StySENI", "StySBLI"],
  site: "cgannnnnntacc",
  forwardRegex: "cga[abcdghkmnrstvwy]{6}tac{2}",
  reverseRegex: "g{2}ta[abcdghkmnrstvwy]{6}tcg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BfaI", "MthZI", "RmaI", "FspBI", "FgoI", "MaeI", "XspI"],
  site: "ctag",
  forwardRegex: "ctag",
  reverseRegex: "ctag",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["BseYI"],
  site: "cccagc",
  forwardRegex: "c{3}agc",
  reverseRegex: "gctg{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["SmlI", "SmoI"],
  site: "ctyrag",
  forwardRegex: "ct[cty][agr]ag",
  reverseRegex: "ct[cty][agr]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Tsp509I", "Sse9I", "TspEI", "TasI"],
  site: "aatt",
  forwardRegex: "a{2}t{2}",
  reverseRegex: "a{2}t{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 4
}, {
  aliases: ["HgaI", "CseI"],
  site: "gacgc",
  forwardRegex: "gacgc",
  reverseRegex: "gcgtc",
  topSnipOffset: 10,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["PaeBI", "PspALI", "SmaI", "CfrJ4I"],
  site: "cccggg",
  forwardRegex: "c{3}g{3}",
  reverseRegex: "c{3}g{3}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["SnaBI", "Eco105I", "BstSNI"],
  site: "tacgta",
  forwardRegex: "tacgta",
  reverseRegex: "tacgta",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["Esp3I", "BstGZ53I", "BsmBI"],
  isType2S: true,
  site: "cgtctc",
  forwardRegex: "cgtctc",
  reverseRegex: "gagacg",
  topSnipOffset: 7,
  bottomSnipOffset: 11
}, {
  aliases: ["Bsp1591I", "Cfr19I", "Uba1291I", "SciAI", "KoxI", "BstDI", "Bse59I", "Bst31I", "Cfr7I"],
  site: "ggtnacc",
  forwardRegex: "g{2}t[abcdghkmnrstvwy]ac{2}",
  reverseRegex: "g{2}t[abcdghkmnrstvwy]ac{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PstII"],
  site: "ctgatg",
  forwardRegex: "ctgatg",
  reverseRegex: "catcag",
  topSnipOffset: 31,
  bottomSnipOffset: 33,
  isType2S: true
}, {
  aliases: ["PflMI", "PflBI", "Asp10HII", "BasI", "Van91I", "AcpII", "Esp1396I", "AccB7I"],
  site: "ccannnnntgg",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{5}tg{2}",
  reverseRegex: "c{2}a[abcdghkmnrstvwy]{5}tg{2}",
  topSnipOffset: 7,
  bottomSnipOffset: 4
}, {
  aliases: ["RceI"],
  site: "catcgac",
  forwardRegex: "catcgac",
  reverseRegex: "gtcgatg",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["BstDEI", "BstJZ301I", "HpyF3I", "DdeI"],
  site: "ctnag",
  forwardRegex: "ct[abcdghkmnrstvwy]ag",
  reverseRegex: "ct[abcdghkmnrstvwy]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["UbaN6I", "Bco631I", "Bco63I", "Bse631I"],
  site: "gatnnnnatc",
  forwardRegex: "gat[abcdghkmnrstvwy]{4}atc",
  reverseRegex: "gat[abcdghkmnrstvwy]{4}atc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["StySJI"],
  site: "gagnnnnnngtrc",
  forwardRegex: "gag[abcdghkmnrstvwy]{6}gt[agr]c",
  reverseRegex: "g[cty]ac[abcdghkmnrstvwy]{6}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BchI", "BsaUI", "BsrVI", "LfeI"],
  site: "gcagc",
  forwardRegex: "gcagc",
  reverseRegex: "gctgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BscAI", "Bst19I"],
  site: "gcatc",
  forwardRegex: "gcatc",
  reverseRegex: "gatgc",
  topSnipOffset: 9,
  bottomSnipOffset: 11,
  isType2S: true
}, {
  aliases: ["KteAI", "Uba1393I", "Uba1220I"],
  site: "cccggg",
  forwardRegex: "c{3}g{3}",
  reverseRegex: "c{3}g{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BctI"],
  site: "acggc",
  forwardRegex: "acg{2}c",
  reverseRegex: "gc{2}gt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BsePI", "PteI", "BssHII", "BstBZ153I", "PauI"],
  site: "gcgcgc",
  forwardRegex: "gcgcgc",
  reverseRegex: "gcgcgc",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["StyLTIII"],
  site: "gagnnnnnnrtayg",
  forwardRegex: "gag[abcdghkmnrstvwy]{6}[agr]ta[cty]g",
  reverseRegex: "c[agr]ta[cty][abcdghkmnrstvwy]{6}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["VpaK32I", "PciSI", "LguI", "BspQI", "SapI"],
  isType2S: true,
  site: "gctcttc",
  forwardRegex: "gctct{2}c",
  reverseRegex: "ga{2}gagc",
  topSnipOffset: 8,
  bottomSnipOffset: 11
}, {
  aliases: ["BniI"],
  site: "gcnngc",
  forwardRegex: "gc[abcdghkmnrstvwy]{2}gc",
  reverseRegex: "gc[abcdghkmnrstvwy]{2}gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoDR2"],
  site: "tcannnnnngtcg",
  forwardRegex: "tca[abcdghkmnrstvwy]{6}gtcg",
  reverseRegex: "cgac[abcdghkmnrstvwy]{6}tga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TssI"],
  site: "gagnnnctc",
  forwardRegex: "gag[abcdghkmnrstvwy]{3}ctc",
  reverseRegex: "gag[abcdghkmnrstvwy]{3}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Tth111II"],
  site: "caarca",
  forwardRegex: "ca{2}[agr]ca",
  reverseRegex: "tg[cty]t{2}g",
  topSnipOffset: 17,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["BbvCI", "AbeI"],
  site: "cctcagc",
  forwardRegex: "c{2}tcagc",
  reverseRegex: "gctgag{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["MluI", "Bbi24I"],
  site: "acgcgt",
  forwardRegex: "acgcgt",
  reverseRegex: "acgcgt",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["MnlI"],
  site: "cctc",
  forwardRegex: "c{2}tc",
  reverseRegex: "gag{2}",
  topSnipOffset: 11,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["SspD5I"],
  site: "ggtga",
  forwardRegex: "g{2}tga",
  reverseRegex: "tcac{2}",
  topSnipOffset: 13,
  bottomSnipOffset: 13,
  isType2S: true
}, {
  aliases: ["AspCNI"],
  site: "gccgc",
  forwardRegex: "gc{2}gc",
  reverseRegex: "gcg{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TauI", "BspUI"],
  site: "gcsgc",
  forwardRegex: "gc[cgs]gc",
  reverseRegex: "gc[cgs]gc",
  topSnipOffset: 4,
  bottomSnipOffset: 1
}, {
  aliases: ["BinSII", "BbeI"],
  site: "ggcgcc",
  forwardRegex: "g{2}cgc{2}",
  reverseRegex: "g{2}cgc{2}",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["BpmI", "GsuI"],
  site: "ctggag",
  forwardRegex: "ctg{2}ag",
  reverseRegex: "ctc{2}ag",
  topSnipOffset: 22,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["NciI", "AhaI", "AseII", "Mgl14481I", "AsuC2I", "BpuMI", "HgiS22I", "CauII", "BcnI"],
  site: "ccsgg",
  forwardRegex: "c{2}[cgs]g{2}",
  reverseRegex: "c{2}[cgs]g{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 3
}, {
  aliases: ["Eco1348I", "Eco777I", "Eco1412I"],
  site: "ggannnnnntatc",
  forwardRegex: "g{2}a[abcdghkmnrstvwy]{6}tatc",
  reverseRegex: "gata[abcdghkmnrstvwy]{6}tc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AgsI"],
  site: "ttsaa",
  forwardRegex: "t{2}[cgs]a{2}",
  reverseRegex: "t{2}[cgs]a{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 2
}, {
  aliases: ["Pfl18I", "Ssm4I", "Ssm5I", "NasSI", "ScoI", "Ecl137I"],
  site: "gagctc",
  forwardRegex: "gagctc",
  reverseRegex: "gagctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CfrBI", "StyI", "ErhB9II", "Eco130I", "ErhI", "EcoT14I", "BsmSI", "BssT1I"],
  site: "ccwwgg",
  forwardRegex: "c{2}[atw]{2}g{2}",
  reverseRegex: "c{2}[atw]{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["AlwFI"],
  site: "gaaaynnnnnrtg",
  forwardRegex: "ga{3}[cty][abcdghkmnrstvwy]{5}[agr]tg",
  reverseRegex: "ca[cty][abcdghkmnrstvwy]{5}[agr]t{3}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CviRI", "HpyCH4V", "HpyF44III"],
  site: "tgca",
  forwardRegex: "tgca",
  reverseRegex: "tgca",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["Bse19I", "AteI", "NspSAIII"],
  site: "ccatgg",
  forwardRegex: "c{2}atg{2}",
  reverseRegex: "c{2}atg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Srl65DI", "Srr17I", "Srl55DII", "CprJK722I", "Srl8DI", "PbuMZI"],
  site: "attaat",
  forwardRegex: "at{2}a{2}t",
  reverseRegex: "at{2}a{2}t",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["ClcII", "GspAII", "NspHIII", "Bco6I", "NspLI", "NspMI", "BsaTI", "CliII", "ApcTR183I", "AcaIII"],
  site: "tgcgca",
  forwardRegex: "tgcgca",
  reverseRegex: "tgcgca",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CsiI", "MabI", "SexAI"],
  site: "accwggt",
  forwardRegex: "ac{2}[atw]g{2}t",
  reverseRegex: "ac{2}[atw]g{2}t",
  topSnipOffset: 1,
  bottomSnipOffset: 6
}, {
  aliases: ["HgiEII"],
  site: "accnnnnnnggt",
  forwardRegex: "ac{2}[abcdghkmnrstvwy]{6}g{2}t",
  reverseRegex: "ac{2}[abcdghkmnrstvwy]{6}g{2}t",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TseDI", "BscRI", "Bsp21I"],
  site: "rccggy",
  forwardRegex: "[agr]c{2}g{2}[cty]",
  reverseRegex: "[agr]c{2}g{2}[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bse23I", "BsmYI"],
  site: "ccnnnnnnngg",
  forwardRegex: "c{2}[abcdghkmnrstvwy]{7}g{2}",
  reverseRegex: "c{2}[abcdghkmnrstvwy]{7}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NdeI", "FauNDI", "PfaAII"],
  site: "catatg",
  forwardRegex: "catatg",
  reverseRegex: "catatg",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["VneAI", "Uba1326I"],
  site: "rggnccy",
  forwardRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  reverseRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SrlI", "NgoMIV", "SceIII", "NgoAIV", "MroNI", "Eco56I"],
  site: "gccggc",
  forwardRegex: "gc{2}g{2}c",
  reverseRegex: "gc{2}g{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["AsiSI", "SfaAI", "RgaI", "SgfI"],
  site: "gcgatcgc",
  forwardRegex: "gcgatcgc",
  reverseRegex: "gcgatcgc",
  topSnipOffset: 5,
  bottomSnipOffset: 3
}, {
  aliases: ["BtsPI", "SaiI", "ShaI"],
  site: "gggtc",
  forwardRegex: "g{3}tc",
  reverseRegex: "gac{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Pfl1108I"],
  site: "tcgtag",
  forwardRegex: "tcgtag",
  reverseRegex: "ctacga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoHK31I", "Bfi89I", "EaeI", "CfrI", "AcoI"],
  site: "yggccr",
  forwardRegex: "[cty]g{2}c{2}[agr]",
  reverseRegex: "[cty]g{2}c{2}[agr]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["HphI", "AsuHPI"],
  site: "ggtga",
  forwardRegex: "g{2}tga",
  reverseRegex: "tcac{2}",
  topSnipOffset: 13,
  bottomSnipOffset: 12,
  isType2S: true
}, {
  aliases: ["Uba1303I", "BstZ5I", "BscNI"],
  site: "cgrycg",
  forwardRegex: "cg[agr][cty]cg",
  reverseRegex: "cg[agr][cty]cg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bsp6II", "FsfI", "BspD6II", "Eco112I", "Eco125I"],
  site: "ctgaag",
  forwardRegex: "ctga{2}g",
  reverseRegex: "ct{2}cag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BstXI", "BstHZ55I"],
  site: "ccannnnnntgg",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{6}tg{2}",
  reverseRegex: "c{2}a[abcdghkmnrstvwy]{6}tg{2}",
  topSnipOffset: 8,
  bottomSnipOffset: 4
}, {
  aliases: ["Ppu11I", "Ppu6I"],
  site: "yacgtr",
  forwardRegex: "[cty]acgt[agr]",
  reverseRegex: "[cty]acgt[agr]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoT104I", "SblAI", "SblBI", "SblCI", "Uba1311I", "Eco208II", "Bst224I"],
  site: "ccwwgg",
  forwardRegex: "c{2}[atw]{2}g{2}",
  reverseRegex: "c{2}[atw]{2}g{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoR124II"],
  site: "gaannnnnnnrtcg",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{7}[agr]tcg",
  reverseRegex: "cga[cty][abcdghkmnrstvwy]{7}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MamI", "BseJI", "Bse8I", "BsrBRI", "BsiBI", "BsaBI", "Bsh1365I"],
  site: "gatnnnnatc",
  forwardRegex: "gat[abcdghkmnrstvwy]{4}atc",
  reverseRegex: "gat[abcdghkmnrstvwy]{4}atc",
  topSnipOffset: 5,
  bottomSnipOffset: 5
}, {
  aliases: ["Ssp5230I", "AatII"],
  site: "gacgtc",
  forwardRegex: "gacgtc",
  reverseRegex: "gacgtc",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["Uba1240I", "Bpu1831I", "SspM1I", "SspM2I", "EciAI", "SspJI", "Eco158II"],
  site: "tacgta",
  forwardRegex: "tacgta",
  reverseRegex: "tacgta",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MaqI"],
  site: "crttgac",
  forwardRegex: "c[agr]t{2}gac",
  reverseRegex: "gtca{2}[cty]g",
  topSnipOffset: 28,
  bottomSnipOffset: 26,
  isType2S: true
}, {
  aliases: ["CjeNII"],
  site: "gagnnnnngt",
  forwardRegex: "gag[abcdghkmnrstvwy]{5}gt",
  reverseRegex: "ac[abcdghkmnrstvwy]{5}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["KpnAI"],
  site: "gaannnnnntgcc",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{6}tgc{2}",
  reverseRegex: "g{2}ca[abcdghkmnrstvwy]{6}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SleI", "AjnI", "Psp6I", "PspGI", "SspAI", "EcoRII"],
  site: "ccwgg",
  forwardRegex: "c{2}[atw]g{2}",
  reverseRegex: "c{2}[atw]g{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["BstFZ438I", "Bme585I", "SmuI", "FauI"],
  site: "cccgc",
  forwardRegex: "c{3}gc",
  reverseRegex: "gcg{3}",
  topSnipOffset: 9,
  bottomSnipOffset: 11,
  isType2S: true
}, {
  aliases: ["HpyCH4IV", "MaeII"],
  site: "acgt",
  forwardRegex: "acgt",
  reverseRegex: "acgt",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["TaqII"],
  site: "caccca",
  forwardRegex: "cac{3}a",
  reverseRegex: "tg{3}tg",
  topSnipOffset: 17,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["UbaN9I"],
  site: "aacgtt",
  forwardRegex: "a{2}cgt{2}",
  reverseRegex: "a{2}cgt{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["DrdII"],
  site: "gaacca",
  forwardRegex: "ga{2}c{2}a",
  reverseRegex: "tg{2}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MalI", "DpnI", "CfuI"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["AarI"],
  isType2S: true,
  site: "cacctgc",
  forwardRegex: "cac{2}tgc",
  reverseRegex: "gcag{2}tg",
  topSnipOffset: 11,
  bottomSnipOffset: 15
}, {
  aliases: ["SrfI"],
  site: "gcccgggc",
  forwardRegex: "gc{3}g{3}c",
  reverseRegex: "gc{3}g{3}c",
  topSnipOffset: 4,
  bottomSnipOffset: 4
}, {
  aliases: ["TatI"],
  site: "wgtacw",
  forwardRegex: "[atw]gtac[atw]",
  reverseRegex: "[atw]gtac[atw]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["EcoDXXI"],
  site: "tcannnnnnnrttc",
  forwardRegex: "tca[abcdghkmnrstvwy]{7}[agr]t{2}c",
  reverseRegex: "ga{2}[cty][abcdghkmnrstvwy]{7}tga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HindII", "HincII", "HinJCI"],
  site: "gtyrac",
  forwardRegex: "gt[cty][agr]ac",
  reverseRegex: "gt[cty][agr]ac",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BseMI", "Bse3DI", "BsrDI"],
  site: "gcaatg",
  forwardRegex: "gca{2}tg",
  reverseRegex: "cat{2}gc",
  topSnipOffset: 8,
  bottomSnipOffset: 6,
  isType2S: true
}, {
  aliases: ["HalI", "Srl32DII", "FunII", "Ppu111I", "EcoRI", "RsrI", "Kpn49kI", "SsoI", "Srl55DI"],
  site: "gaattc",
  forwardRegex: "ga{2}t{2}c",
  reverseRegex: "ga{2}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Hpy166III"],
  site: "cctc",
  forwardRegex: "c{2}tc",
  reverseRegex: "gag{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["FspAI"],
  site: "rtgcgcay",
  forwardRegex: "[agr]tgcgca[cty]",
  reverseRegex: "[agr]tgcgca[cty]",
  topSnipOffset: 4,
  bottomSnipOffset: 4
}, {
  aliases: ["Eco585I"],
  site: "gccnnnnnntgcg",
  forwardRegex: "gc{2}[abcdghkmnrstvwy]{6}tgcg",
  reverseRegex: "cgca[abcdghkmnrstvwy]{6}g{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PlaDI"],
  site: "catcag",
  forwardRegex: "catcag",
  reverseRegex: "ctgatg",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["Hpy188I"],
  site: "tcnga",
  forwardRegex: "tc[abcdghkmnrstvwy]ga",
  reverseRegex: "tc[abcdghkmnrstvwy]ga",
  topSnipOffset: 3,
  bottomSnipOffset: 2
}, {
  aliases: ["PciI", "PscI", "BspLU11I"],
  site: "acatgt",
  forwardRegex: "acatgt",
  reverseRegex: "acatgt",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["VchO25I", "SnaI"],
  site: "gtatac",
  forwardRegex: "gtatac",
  reverseRegex: "gtatac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TseBI", "M.BbvSI", "TneI"],
  site: "gcwgc",
  forwardRegex: "gc[atw]gc",
  reverseRegex: "gc[atw]gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["OliI", "AleI"],
  site: "cacnnnngtg",
  forwardRegex: "cac[abcdghkmnrstvwy]{4}gtg",
  reverseRegex: "cac[abcdghkmnrstvwy]{4}gtg",
  topSnipOffset: 5,
  bottomSnipOffset: 5
}, {
  aliases: ["GlaI"],
  site: "gcgc",
  forwardRegex: "gcgc",
  reverseRegex: "gcgc",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["BssGI", "BscJI", "BstTI"],
  site: "ccannnnnntgg",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{6}tg{2}",
  reverseRegex: "c{2}a[abcdghkmnrstvwy]{6}tg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Tsp4CI", "Bst4CI", "HpyCH4III", "TaaI"],
  site: "acngt",
  forwardRegex: "ac[abcdghkmnrstvwy]gt",
  reverseRegex: "ac[abcdghkmnrstvwy]gt",
  topSnipOffset: 3,
  bottomSnipOffset: 2
}, {
  aliases: ["AceIII"],
  site: "cagctc",
  forwardRegex: "cagctc",
  reverseRegex: "gagctg",
  topSnipOffset: 13,
  bottomSnipOffset: 17,
  isType2S: true
}, {
  aliases: ["BseNI", "BsrI", "Bse1I", "Tsp1I", "BsrSI", "Bst11I"],
  site: "actgg",
  forwardRegex: "actg{2}",
  reverseRegex: "c{2}agt",
  topSnipOffset: 6,
  bottomSnipOffset: 4,
  isType2S: true
}, {
  aliases: ["FnuAI", "HinfI", "CviBI", "HhaII", "SscL1I"],
  site: "gantc",
  forwardRegex: "ga[abcdghkmnrstvwy]tc",
  reverseRegex: "ga[abcdghkmnrstvwy]tc",
  topSnipOffset: 1,
  bottomSnipOffset: 4
}, {
  aliases: ["CjuI"],
  site: "caynnnnnrtg",
  forwardRegex: "ca[cty][abcdghkmnrstvwy]{5}[agr]tg",
  reverseRegex: "ca[cty][abcdghkmnrstvwy]{5}[agr]tg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF2I", "Bco163I"],
  site: "ctryag",
  forwardRegex: "ct[agr][cty]ag",
  reverseRegex: "ct[agr][cty]ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AanI", "PsiI"],
  site: "ttataa",
  forwardRegex: "t{2}ata{2}",
  reverseRegex: "t{2}ata{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["StySPI"],
  site: "aacnnnnnngtrc",
  forwardRegex: "a{2}c[abcdghkmnrstvwy]{6}gt[agr]c",
  reverseRegex: "g[cty]ac[abcdghkmnrstvwy]{6}gt{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BpuJI", "BstDZ247I", "BscGI"],
  site: "cccgt",
  forwardRegex: "c{3}gt",
  reverseRegex: "acg{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Hpy99I"],
  site: "cgwcg",
  forwardRegex: "cg[atw]cg",
  reverseRegex: "cg[atw]cg",
  topSnipOffset: 5,
  bottomSnipOffset: 0
}, {
  aliases: ["BceSI"],
  site: "mmcgaag",
  forwardRegex: "[acm]{2}cga{2}g",
  reverseRegex: "ct{2}cg[gkt]{2}",
  topSnipOffset: 32,
  bottomSnipOffset: 34,
  isType2S: true
}, {
  aliases: ["HaeI"],
  site: "wggccw",
  forwardRegex: "[atw]g{2}c{2}[atw]",
  reverseRegex: "[atw]g{2}c{2}[atw]",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["PspPRI"],
  site: "ccycag",
  forwardRegex: "c{2}[cty]cag",
  reverseRegex: "ctg[agr]g{2}",
  topSnipOffset: 21,
  bottomSnipOffset: 19,
  isType2S: true
}, {
  aliases: ["FokI"],
  site: "ggatg",
  forwardRegex: "g{2}atg",
  reverseRegex: "catc{2}",
  topSnipOffset: 14,
  bottomSnipOffset: 18,
  isType2S: true
}, {
  aliases: ["NgoBV", "NgoGV", "Bsp29I", "HpyF44II", "Uba1445I", "Uba1305I", "HpyF73I", "BsaEI", "BcrI", "Rlu3I", "BssI"],
  site: "ggnncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]{2}c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]{2}c{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bce1247I"],
  site: "gcnnnnnnngc",
  forwardRegex: "gc[abcdghkmnrstvwy]{7}gc",
  reverseRegex: "gc[abcdghkmnrstvwy]{7}gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AasI", "DrdI", "DseDI"],
  site: "gacnnnnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{6}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{6}gtc",
  topSnipOffset: 7,
  bottomSnipOffset: 5
}, {
  aliases: ["M.SssI"],
  site: "cg",
  forwardRegex: "cg",
  reverseRegex: "cg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyF61III"],
  site: "cgwcg",
  forwardRegex: "cg[atw]cg",
  reverseRegex: "cg[atw]cg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AflIII"],
  site: "acrygt",
  forwardRegex: "ac[agr][cty]gt",
  reverseRegex: "ac[agr][cty]gt",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Asp700I", "BbvAI", "MroXI", "XmnI", "PdmI"],
  site: "gaannnnttc",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{4}t{2}c",
  reverseRegex: "ga{2}[abcdghkmnrstvwy]{4}t{2}c",
  topSnipOffset: 5,
  bottomSnipOffset: 5
}, {
  aliases: ["ChaI"],
  site: "gatc",
  forwardRegex: "gatc",
  reverseRegex: "gatc",
  topSnipOffset: 4,
  bottomSnipOffset: 0
}, {
  aliases: ["EcoEI"],
  site: "gagnnnnnnnatgc",
  forwardRegex: "gag[abcdghkmnrstvwy]{7}atgc",
  reverseRegex: "gcat[abcdghkmnrstvwy]{7}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BspAAII", "XbaI"],
  site: "tctaga",
  forwardRegex: "tctaga",
  reverseRegex: "tctaga",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["Hpy188III", "Hpy178III"],
  site: "tcnnga",
  forwardRegex: "tc[abcdghkmnrstvwy]{2}ga",
  reverseRegex: "tc[abcdghkmnrstvwy]{2}ga",
  topSnipOffset: 2,
  bottomSnipOffset: 4
}, {
  aliases: ["McaTI"],
  site: "gcgcgc",
  forwardRegex: "gcgcgc",
  reverseRegex: "gcgcgc",
  topSnipOffset: 4,
  bottomSnipOffset: 2
}, {
  aliases: ["BstZ9I", "Uba6I", "ApeI"],
  site: "acgcgt",
  forwardRegex: "acgcgt",
  reverseRegex: "acgcgt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BspNCI"],
  site: "ccaga",
  forwardRegex: "c{2}aga",
  reverseRegex: "tctg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoHI", "Eco1831I", "Kpn49kII"],
  site: "ccsgg",
  forwardRegex: "c{2}[cgs]g{2}",
  reverseRegex: "c{2}[cgs]g{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["PpsI", "PleI"],
  site: "gagtc",
  forwardRegex: "gagtc",
  reverseRegex: "gactc",
  topSnipOffset: 9,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["BfuI", "BciVI"],
  site: "gtatcc",
  forwardRegex: "gtatc{2}",
  reverseRegex: "g{2}atac",
  topSnipOffset: 12,
  bottomSnipOffset: 11,
  isType2S: true
}, {
  aliases: ["TthHB27I"],
  site: "caarca",
  forwardRegex: "ca{2}[agr]ca",
  reverseRegex: "tg[cty]t{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PspXI"],
  site: "vctcgagb",
  forwardRegex: "[acgmrsv]ctcgag[bcgksty]",
  reverseRegex: "[acgmrsv]ctcgag[bcgksty]",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["Lsp1270I"],
  site: "rcatgy",
  forwardRegex: "[agr]catg[cty]",
  reverseRegex: "[agr]catg[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyC1I", "BccI"],
  site: "ccatc",
  forwardRegex: "c{2}atc",
  reverseRegex: "gatg{2}",
  topSnipOffset: 9,
  bottomSnipOffset: 10,
  isType2S: true
}, {
  aliases: ["BseMII"],
  site: "ctcag",
  forwardRegex: "ctcag",
  reverseRegex: "ctgag",
  topSnipOffset: 15,
  bottomSnipOffset: 13,
  isType2S: true
}, {
  aliases: ["BstENI", "EcoNI", "XagI"],
  site: "cctnnnnnagg",
  forwardRegex: "c{2}t[abcdghkmnrstvwy]{5}ag{2}",
  reverseRegex: "c{2}t[abcdghkmnrstvwy]{5}ag{2}",
  topSnipOffset: 5,
  bottomSnipOffset: 6
}, {
  aliases: ["EcoAI", "Eco1446I"],
  site: "gagnnnnnnngtca",
  forwardRegex: "gag[abcdghkmnrstvwy]{7}gtca",
  reverseRegex: "tgac[abcdghkmnrstvwy]{7}ctc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MmeI"],
  site: "tccrac",
  forwardRegex: "tc{2}[agr]ac",
  reverseRegex: "gt[cty]g{2}a",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["AjiI", "BmgBI", "BtrI"],
  site: "cacgtc",
  forwardRegex: "cacgtc",
  reverseRegex: "gacgtg",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BlsI"],
  site: "gcngc",
  forwardRegex: "gc[abcdghkmnrstvwy]gc",
  reverseRegex: "gc[abcdghkmnrstvwy]gc",
  topSnipOffset: 3,
  bottomSnipOffset: 2
}, {
  aliases: ["Bst170I", "BsmGI"],
  site: "tgtaca",
  forwardRegex: "tgtaca",
  reverseRegex: "tgtaca",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["HpyBII", "Hpy166II", "Hpy8I"],
  site: "gtnnac",
  forwardRegex: "gt[abcdghkmnrstvwy]{2}ac",
  reverseRegex: "gt[abcdghkmnrstvwy]{2}ac",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["StySKI"],
  site: "cgatnnnnnnngtta",
  forwardRegex: "cgat[abcdghkmnrstvwy]{7}gt{2}a",
  reverseRegex: "ta{2}c[abcdghkmnrstvwy]{7}atcg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Esp23I", "Esp16I"],
  site: "cgtctc",
  forwardRegex: "cgtctc",
  reverseRegex: "gagacg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BmgT120I"],
  site: "ggncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 3
}, {
  aliases: ["BcoAI", "BbrPI", "PmlI", "PspCI", "PmaCI", "Eco72I", "AcvI"],
  site: "cacgtg",
  forwardRegex: "cacgtg",
  reverseRegex: "cacgtg",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["CjeP338II", "BscUI", "BsmNI", "BhaI"],
  site: "gcatc",
  forwardRegex: "gcatc",
  reverseRegex: "gatgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["KasI", "SspDI"],
  site: "ggcgcc",
  forwardRegex: "g{2}cgc{2}",
  reverseRegex: "g{2}cgc{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["FmuI"],
  site: "ggncc",
  forwardRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  reverseRegex: "g{2}[abcdghkmnrstvwy]c{2}",
  topSnipOffset: 4,
  bottomSnipOffset: 1
}, {
  aliases: ["RseI", "MslI", "SmiMI"],
  site: "caynnnnrtg",
  forwardRegex: "ca[cty][abcdghkmnrstvwy]{4}[agr]tg",
  reverseRegex: "ca[cty][abcdghkmnrstvwy]{4}[agr]tg",
  topSnipOffset: 5,
  bottomSnipOffset: 5
}, {
  aliases: ["NmuCI", "Tsp45I", "Hpy51I"],
  site: "gtsac",
  forwardRegex: "gt[cgs]ac",
  reverseRegex: "gt[cgs]ac",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["Psp5II", "PpuMI", "PpuXI", "Pfl27I", "PspPPI"],
  site: "rggwccy",
  forwardRegex: "[agr]g{2}[atw]c{2}[cty]",
  reverseRegex: "[agr]g{2}[atw]c{2}[cty]",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["Bba179I", "Bst1473I", "UbaN10I"],
  site: "wccggw",
  forwardRegex: "[atw]c{2}g{2}[atw]",
  reverseRegex: "[atw]c{2}g{2}[atw]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco912I"],
  site: "cacnnnnntggc",
  forwardRegex: "cac[abcdghkmnrstvwy]{5}tg{2}c",
  reverseRegex: "gc{2}a[abcdghkmnrstvwy]{5}gtg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SsmI"],
  site: "ctgatg",
  forwardRegex: "ctgatg",
  reverseRegex: "catcag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EsaSSI"],
  site: "gaccac",
  forwardRegex: "gac{2}ac",
  reverseRegex: "gtg{2}tc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoDI"],
  site: "ttannnnnnngtcy",
  forwardRegex: "t{2}a[abcdghkmnrstvwy]{7}gtc[cty]",
  reverseRegex: "[agr]gac[abcdghkmnrstvwy]{7}ta{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BsoHI", "BscHI"],
  site: "actgg",
  forwardRegex: "actg{2}",
  reverseRegex: "c{2}agt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NmeBI"],
  site: "gacgc",
  forwardRegex: "gacgc",
  reverseRegex: "gcgtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NspBII", "MspA1I"],
  site: "cmgckg",
  forwardRegex: "c[acm]gc[gkt]g",
  reverseRegex: "c[acm]gc[gkt]g",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["BmgAI"],
  site: "gkgcmc",
  forwardRegex: "g[gkt]gc[acm]c",
  reverseRegex: "g[gkt]gc[acm]c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NmeAIII"],
  site: "gccgag",
  forwardRegex: "gc{2}gag",
  reverseRegex: "ctcg{2}c",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["DrdIV"],
  site: "tacgac",
  forwardRegex: "tacgac",
  reverseRegex: "gtcgta",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["BscQII"],
  site: "gtctc",
  forwardRegex: "gtctc",
  reverseRegex: "gagac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AbsI"],
  site: "cctcgagg",
  forwardRegex: "c{2}tcgag{2}",
  reverseRegex: "c{2}tcgag{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["Psp03I"],
  site: "ggwcc",
  forwardRegex: "g{2}[atw]c{2}",
  reverseRegex: "g{2}[atw]c{2}",
  topSnipOffset: 4,
  bottomSnipOffset: 1
}, {
  aliases: ["BmtI", "BspOI", "AceII"],
  site: "gctagc",
  forwardRegex: "gctagc",
  reverseRegex: "gctagc",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["GsaI"],
  site: "cccagc",
  forwardRegex: "c{3}agc",
  reverseRegex: "gctg{3}",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaF9I"],
  site: "tacnnnnnrtgt",
  forwardRegex: "tac[abcdghkmnrstvwy]{5}[agr]tgt",
  reverseRegex: "aca[cty][abcdghkmnrstvwy]{5}gta",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Hin1II", "NlaIII", "FaeI", "Hsp92II", "HpyCH4I"],
  site: "catg",
  forwardRegex: "catg",
  reverseRegex: "catg",
  topSnipOffset: 4,
  bottomSnipOffset: 0
}, {
  aliases: ["Bbr7I"],
  site: "gaagac",
  forwardRegex: "ga{2}gac",
  reverseRegex: "gtct{2}c",
  topSnipOffset: 13,
  bottomSnipOffset: 17,
  isType2S: true
}, {
  aliases: ["Kaz48kI", "PssI"],
  site: "rggnccy",
  forwardRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  reverseRegex: "[agr]g{2}[abcdghkmnrstvwy]c{2}[cty]",
  topSnipOffset: 5,
  bottomSnipOffset: 2
}, {
  aliases: ["BoxI", "BstPAI", "PshAI"],
  site: "gacnnnngtc",
  forwardRegex: "gac[abcdghkmnrstvwy]{4}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{4}gtc",
  topSnipOffset: 5,
  bottomSnipOffset: 5
}, {
  aliases: ["SgrDI"],
  site: "cgtcgacg",
  forwardRegex: "cgtcgacg",
  reverseRegex: "cgtcgacg",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["BssIMI", "SimI"],
  site: "gggtc",
  forwardRegex: "g{3}tc",
  reverseRegex: "gac{3}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["RleAI"],
  site: "cccaca",
  forwardRegex: "c{3}aca",
  reverseRegex: "tgtg{3}",
  topSnipOffset: 18,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["EciI"],
  site: "ggcgga",
  forwardRegex: "g{2}cg{2}a",
  reverseRegex: "tc{2}gc{2}",
  topSnipOffset: 17,
  bottomSnipOffset: 15,
  isType2S: true
}, {
  aliases: ["Eco57MI"],
  site: "ctgrag",
  forwardRegex: "ctg[agr]ag",
  reverseRegex: "ct[cty]cag",
  topSnipOffset: 22,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["AspJI", "Ppu1253I"],
  site: "gacgtc",
  forwardRegex: "gacgtc",
  reverseRegex: "gacgtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaF11I"],
  site: "tcgta",
  forwardRegex: "tcgta",
  reverseRegex: "tacga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SetI"],
  site: "asst",
  forwardRegex: "a[cgs]{2}t",
  reverseRegex: "a[cgs]{2}t",
  topSnipOffset: 4,
  bottomSnipOffset: 0
}, {
  aliases: ["PspOMII"],
  site: "cgcccar",
  forwardRegex: "cgc{3}a[agr]",
  reverseRegex: "[cty]tg{3}cg",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["BsxI"],
  site: "actggg",
  forwardRegex: "actg{3}",
  reverseRegex: "c{3}agt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco394I"],
  site: "gacnnnnnrtaay",
  forwardRegex: "gac[abcdghkmnrstvwy]{5}[agr]ta{2}[cty]",
  reverseRegex: "[agr]t{2}a[cty][abcdghkmnrstvwy]{5}gtc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["ApyPI"],
  site: "atcgac",
  forwardRegex: "atcgac",
  reverseRegex: "gtcgat",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["AlwNI", "CaiI"],
  site: "cagnnnctg",
  forwardRegex: "cag[abcdghkmnrstvwy]{3}ctg",
  reverseRegex: "cag[abcdghkmnrstvwy]{3}ctg",
  topSnipOffset: 6,
  bottomSnipOffset: 3
}, {
  aliases: ["TsuI"],
  site: "gcgac",
  forwardRegex: "gcgac",
  reverseRegex: "gtcgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Bca77I", "BsaWI", "BetI"],
  site: "wccggw",
  forwardRegex: "[atw]c{2}g{2}[atw]",
  reverseRegex: "[atw]c{2}g{2}[atw]",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["EcoDR3"],
  site: "tcannnnnnnatcg",
  forwardRegex: "tca[abcdghkmnrstvwy]{7}atcg",
  reverseRegex: "cgat[abcdghkmnrstvwy]{7}tga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SgrAI"],
  site: "crccggyg",
  forwardRegex: "c[agr]c{2}g{2}[cty]g",
  reverseRegex: "c[agr]c{2}g{2}[cty]g",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["M.NgoMXV"],
  site: "gcchr",
  forwardRegex: "gc{2}[achmtwy][agr]",
  reverseRegex: "[cty][adgkrtw]g{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["EcoRD2"],
  site: "gaannnnnnrttc",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{6}[agr]t{2}c",
  reverseRegex: "ga{2}[cty][abcdghkmnrstvwy]{6}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TspGWI"],
  site: "acgga",
  forwardRegex: "acg{2}a",
  reverseRegex: "tc{2}gt",
  topSnipOffset: 16,
  bottomSnipOffset: 14,
  isType2S: true
}, {
  aliases: ["CviAII"],
  site: "catg",
  forwardRegex: "catg",
  reverseRegex: "catg",
  topSnipOffset: 1,
  bottomSnipOffset: 3
}, {
  aliases: ["XcmI"],
  site: "ccannnnnnnnntgg",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{9}tg{2}",
  reverseRegex: "c{2}a[abcdghkmnrstvwy]{9}tg{2}",
  topSnipOffset: 8,
  bottomSnipOffset: 7
}, {
  aliases: ["EcoRD3"],
  site: "gaannnnnnnrttc",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{7}[agr]t{2}c",
  reverseRegex: "ga{2}[cty][abcdghkmnrstvwy]{7}t{2}c",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SpoDI"],
  site: "gcggrag",
  forwardRegex: "gcg{2}[agr]ag",
  reverseRegex: "ct[cty]c{2}gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaN12I"],
  site: "cacgag",
  forwardRegex: "cacgag",
  reverseRegex: "ctcgtg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PspFI"],
  site: "cccagc",
  forwardRegex: "c{3}agc",
  reverseRegex: "gctg{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PfoI"],
  site: "tccngga",
  forwardRegex: "tc{2}[abcdghkmnrstvwy]g{2}a",
  reverseRegex: "tc{2}[abcdghkmnrstvwy]g{2}a",
  topSnipOffset: 1,
  bottomSnipOffset: 6
}, {
  aliases: ["Sse8647I"],
  site: "aggwcct",
  forwardRegex: "ag{2}[atw]c{2}t",
  reverseRegex: "ag{2}[atw]c{2}t",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["KflI", "Sse1825I", "SanDI"],
  site: "gggwccc",
  forwardRegex: "g{3}[atw]c{3}",
  reverseRegex: "g{3}[atw]c{3}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["Sth132I"],
  site: "cccg",
  forwardRegex: "c{3}g",
  reverseRegex: "cg{3}",
  topSnipOffset: 8,
  bottomSnipOffset: 12,
  isType2S: true
}, {
  aliases: ["CdpI"],
  site: "gcggag",
  forwardRegex: "gcg{2}ag",
  reverseRegex: "ctc{2}gc",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["Asp90I"],
  site: "acrygt",
  forwardRegex: "ac[agr][cty]gt",
  reverseRegex: "ac[agr][cty]gt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["M.CviPI"],
  site: "gc",
  forwardRegex: "gc",
  reverseRegex: "gc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["MauBI"],
  site: "cgcgcgcg",
  forwardRegex: "cgcgcgcg",
  reverseRegex: "cgcgcgcg",
  topSnipOffset: 2,
  bottomSnipOffset: 6
}, {
  aliases: ["CfrAI"],
  site: "gcannnnnnnngtgg",
  forwardRegex: "gca[abcdghkmnrstvwy]{8}gtg{2}",
  reverseRegex: "c{2}ac[abcdghkmnrstvwy]{8}tgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Eco851I"],
  site: "gtcannnnnntgay",
  forwardRegex: "gtca[abcdghkmnrstvwy]{6}tga[cty]",
  reverseRegex: "[agr]tca[abcdghkmnrstvwy]{6}tgac",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BsgI"],
  site: "gtgcag",
  forwardRegex: "gtgcag",
  reverseRegex: "ctgcac",
  topSnipOffset: 22,
  bottomSnipOffset: 20,
  isType2S: true
}, {
  aliases: ["AquIV"],
  site: "grggaag",
  forwardRegex: "g[agr]g{2}a{2}g",
  reverseRegex: "ct{2}c{2}[cty]c",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["SciI"],
  site: "ctcgag",
  forwardRegex: "ctcgag",
  reverseRegex: "ctcgag",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["VpaK11AI"],
  site: "ggwcc",
  forwardRegex: "g{2}[atw]c{2}",
  reverseRegex: "g{2}[atw]c{2}",
  topSnipOffset: 0,
  bottomSnipOffset: 5
}, {
  aliases: ["CviKI", "CviJI", "CviKI-1"],
  site: "rgcy",
  forwardRegex: "[agr]gc[cty]",
  reverseRegex: "[agr]gc[cty]",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["SnoI", "VneI", "ApaLI", "Alw44I"],
  site: "gtgcac",
  forwardRegex: "gtgcac",
  reverseRegex: "gtgcac",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["BspD6I"],
  site: "gactc",
  forwardRegex: "gactc",
  reverseRegex: "gagtc",
  topSnipOffset: 9,
  bottomSnipOffset: 11,
  isType2S: true
}, {
  aliases: ["FatI"],
  site: "catg",
  forwardRegex: "catg",
  reverseRegex: "catg",
  topSnipOffset: 0,
  bottomSnipOffset: 4
}, {
  aliases: ["ZraI"],
  site: "gacgtc",
  forwardRegex: "gacgtc",
  reverseRegex: "gacgtc",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["HineI", "HinfIII"],
  site: "cgaat",
  forwardRegex: "cga{2}t",
  reverseRegex: "at{2}cg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaF12I"],
  site: "ctacnnngtc",
  forwardRegex: "ctac[abcdghkmnrstvwy]{3}gtc",
  reverseRegex: "gac[abcdghkmnrstvwy]{3}gtag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Ppu10I"],
  site: "atgcat",
  forwardRegex: "atgcat",
  reverseRegex: "atgcat",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["ApaBI"],
  site: "gcannnnntgc",
  forwardRegex: "gca[abcdghkmnrstvwy]{5}tgc",
  reverseRegex: "gca[abcdghkmnrstvwy]{5}tgc",
  topSnipOffset: 8,
  bottomSnipOffset: 3
}, {
  aliases: ["NhaXI"],
  site: "caagrag",
  forwardRegex: "ca{2}g[agr]ag",
  reverseRegex: "ct[cty]ct{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["PabI"],
  site: "gtac",
  forwardRegex: "gtac",
  reverseRegex: "gtac",
  topSnipOffset: 3,
  bottomSnipOffset: 1
}, {
  aliases: ["HindI"],
  site: "cac",
  forwardRegex: "cac",
  reverseRegex: "gtg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["M.PhiMx8I"],
  site: "ctssag",
  forwardRegex: "ct[cgs]{2}ag",
  reverseRegex: "ct[cgs]{2}ag",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["RhcI"],
  site: "tcatga",
  forwardRegex: "tcatga",
  reverseRegex: "tcatga",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["KpnI"],
  site: "ggtacc",
  forwardRegex: "g{2}tac{2}",
  reverseRegex: "g{2}tac{2}",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["BpuDI", "Bpu10I"],
  site: "cctnagc",
  forwardRegex: "c{2}t[abcdghkmnrstvwy]agc",
  reverseRegex: "gct[abcdghkmnrstvwy]ag{2}",
  topSnipOffset: 2,
  bottomSnipOffset: 5
}, {
  aliases: ["EcoP15I"],
  site: "cagcag",
  forwardRegex: "cagcag",
  reverseRegex: "ctgctg",
  topSnipOffset: 31,
  bottomSnipOffset: 33,
  isType2S: true
}, {
  aliases: ["Nli3877I"],
  site: "cycgrg",
  forwardRegex: "c[cty]cg[agr]g",
  reverseRegex: "c[cty]cg[agr]g",
  topSnipOffset: 5,
  bottomSnipOffset: 1
}, {
  aliases: ["StySEAI"],
  site: "acannnnnntyca",
  forwardRegex: "aca[abcdghkmnrstvwy]{6}t[cty]ca",
  reverseRegex: "tg[agr]a[abcdghkmnrstvwy]{6}tgt",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["M.CviAIV"],
  site: "rgcb",
  forwardRegex: "[agr]gc[bcgksty]",
  reverseRegex: "[acgmrsv]gc[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["Msp16I"],
  site: "tggcca",
  forwardRegex: "tg{2}c{2}a",
  reverseRegex: "tg{2}c{2}a",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["SasI"],
  site: "gaggag",
  forwardRegex: "gag{2}ag",
  reverseRegex: "ctc{2}tc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["AquIII"],
  site: "gaggag",
  forwardRegex: "gag{2}ag",
  reverseRegex: "ctc{2}tc",
  topSnipOffset: 26,
  bottomSnipOffset: 24,
  isType2S: true
}, {
  aliases: ["FaiI"],
  site: "yatr",
  forwardRegex: "[cty]at[agr]",
  reverseRegex: "[cty]at[agr]",
  topSnipOffset: 2,
  bottomSnipOffset: 2
}, {
  aliases: ["BsbI"],
  site: "caacac",
  forwardRegex: "ca{2}cac",
  reverseRegex: "gtgt{2}g",
  topSnipOffset: 27,
  bottomSnipOffset: 25,
  isType2S: true
}, {
  aliases: ["NgoAV"],
  site: "gcannnnnnnntgc",
  forwardRegex: "gca[abcdghkmnrstvwy]{8}tgc",
  reverseRegex: "gca[abcdghkmnrstvwy]{8}tgc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["BstAPI"],
  site: "gcannnnntgc",
  forwardRegex: "gca[abcdghkmnrstvwy]{5}tgc",
  reverseRegex: "gca[abcdghkmnrstvwy]{5}tgc",
  topSnipOffset: 7,
  bottomSnipOffset: 4
}, {
  aliases: ["BsmEI"],
  site: "gagtc",
  forwardRegex: "gagtc",
  reverseRegex: "gactc",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NcuII"],
  site: "cccg",
  forwardRegex: "c{3}g",
  reverseRegex: "cg{3}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["CviMI", "CviNI", "CviLI", "CviOI"],
  site: "rgcy",
  forwardRegex: "[agr]gc[cty]",
  reverseRegex: "[agr]gc[cty]",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["StySGI"],
  site: "taannnnnnrtcg",
  forwardRegex: "ta{2}[abcdghkmnrstvwy]{6}[agr]tcg",
  reverseRegex: "cga[cty][abcdghkmnrstvwy]{6}t{2}a",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaF14I"],
  site: "ccannnnntcg",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{5}tcg",
  reverseRegex: "cga[abcdghkmnrstvwy]{5}tg{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["UbaPI"],
  site: "cgaacg",
  forwardRegex: "cga{2}cg",
  reverseRegex: "cgt{2}cg",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["TspDTI"],
  site: "atgaa",
  forwardRegex: "atga{2}",
  reverseRegex: "t{2}cat",
  topSnipOffset: 16,
  bottomSnipOffset: 14,
  isType2S: true
}, {
  aliases: ["SspI"],
  site: "aatatt",
  forwardRegex: "a{2}tat{2}",
  reverseRegex: "a{2}tat{2}",
  topSnipOffset: 3,
  bottomSnipOffset: 3
}, {
  aliases: ["GdiII"],
  site: "cggccr",
  forwardRegex: "cg{2}c{2}[agr]",
  reverseRegex: "[cty]g{2}c{2}g",
  topSnipOffset: 1,
  bottomSnipOffset: 5
}, {
  aliases: ["StySQI"],
  site: "aacnnnnnnrtayg",
  forwardRegex: "a{2}c[abcdghkmnrstvwy]{6}[agr]ta[cty]g",
  reverseRegex: "c[agr]ta[cty][abcdghkmnrstvwy]{6}gt{2}",
  topSnipOffset: 1,
  bottomSnipOffset: 1
}, {
  aliases: ["NlaCI"],
  site: "catcac",
  forwardRegex: "catcac",
  reverseRegex: "gtgatg",
  topSnipOffset: 25,
  bottomSnipOffset: 23,
  isType2S: true
}, {
  aliases: ["PacI"],
  site: "ttaattaa",
  forwardRegex: "t{2}a{2}t{2}a{2}",
  reverseRegex: "t{2}a{2}t{2}a{2}",
  topSnipOffset: 5,
  bottomSnipOffset: 3
}, {
  aliases: ["BarI"],
  isType2S: true,
  site: "gaagnnnnnntac",
  forwardRegex: "ga{2}g[abcdghkmnrstvwy]{6}tac",
  reverseRegex: "gta[abcdghkmnrstvwy]{6}ct{2}c",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20
}, {
  aliases: ["CspCI"],
  isType2S: true,
  site: "caannnnngtgg",
  forwardRegex: "ca{2}[abcdghkmnrstvwy]{5}gtg{2}",
  reverseRegex: "c{2}ac[abcdghkmnrstvwy]{5}t{2}g",
  topSnipOffset: 24,
  bottomSnipOffset: 22,
  cutType: 1,
  usForward: 24,
  usReverse: 22
}, {
  aliases: ["NmeDI"],
  site: "rccggy",
  forwardRegex: "[agr]c{2}g{2}[cty]",
  reverseRegex: "[agr]c{2}g{2}[cty]",
  topSnipOffset: 13,
  bottomSnipOffset: 18,
  cutType: 1,
  usForward: 13,
  usReverse: 18,
  isType2S: true
}, {
  aliases: ["CjePI"],
  site: "ccannnnnnntc",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{7}tc",
  reverseRegex: "ga[abcdghkmnrstvwy]{7}tg{2}",
  topSnipOffset: 26,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 26,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["CjeI"],
  site: "ccannnnnngt",
  forwardRegex: "c{2}a[abcdghkmnrstvwy]{6}gt",
  reverseRegex: "ac[abcdghkmnrstvwy]{6}tg{2}",
  topSnipOffset: 26,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 26,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["PsrI"],
  site: "gaacnnnnnntac",
  forwardRegex: "ga{2}c[abcdghkmnrstvwy]{6}tac",
  reverseRegex: "gta[abcdghkmnrstvwy]{6}gt{2}c",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["ArsI"],
  site: "gacnnnnnnttyg",
  forwardRegex: "gac[abcdghkmnrstvwy]{6}t{2}[cty]g",
  reverseRegex: "c[agr]a{2}[abcdghkmnrstvwy]{6}gtc",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["TstI"],
  site: "cacnnnnnntcc",
  forwardRegex: "cac[abcdghkmnrstvwy]{6}tc{2}",
  reverseRegex: "g{2}a[abcdghkmnrstvwy]{6}gtg",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["Bsp24I"],
  site: "gacnnnnnntgg",
  forwardRegex: "gac[abcdghkmnrstvwy]{6}tg{2}",
  reverseRegex: "c{2}a[abcdghkmnrstvwy]{6}gtc",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["AloI"],
  site: "gaacnnnnnntcc",
  forwardRegex: "ga{2}c[abcdghkmnrstvwy]{6}tc{2}",
  reverseRegex: "g{2}a[abcdghkmnrstvwy]{6}gt{2}c",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["FalI"],
  site: "aagnnnnnctt",
  forwardRegex: "a{2}g[abcdghkmnrstvwy]{5}ct{2}",
  reverseRegex: "a{2}g[abcdghkmnrstvwy]{5}ct{2}",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["AjuI"],
  site: "gaannnnnnnttgg",
  forwardRegex: "ga{2}[abcdghkmnrstvwy]{7}t{2}g{2}",
  reverseRegex: "c{2}a{2}[abcdghkmnrstvwy]{7}t{2}c",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["AlfI"],
  site: "gcannnnnntgc",
  forwardRegex: "gca[abcdghkmnrstvwy]{6}tgc",
  reverseRegex: "gca[abcdghkmnrstvwy]{6}tgc",
  topSnipOffset: 24,
  bottomSnipOffset: 22,
  cutType: 1,
  usForward: 24,
  usReverse: 22,
  isType2S: true
}, {
  aliases: ["NgoAVIII"],
  site: "gacnnnnntga",
  forwardRegex: "gac[abcdghkmnrstvwy]{5}tga",
  reverseRegex: "tca[abcdghkmnrstvwy]{5}gtc",
  topSnipOffset: 24,
  bottomSnipOffset: 22,
  cutType: 1,
  usForward: 24,
  usReverse: 22,
  isType2S: true
}, {
  aliases: ["HaeIV"],
  site: "gaynnnnnrtc",
  forwardRegex: "ga[cty][abcdghkmnrstvwy]{5}[agr]tc",
  reverseRegex: "ga[cty][abcdghkmnrstvwy]{5}[agr]tc",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["BdaI"],
  site: "tgannnnnntca",
  forwardRegex: "tga[abcdghkmnrstvwy]{6}tca",
  reverseRegex: "tga[abcdghkmnrstvwy]{6}tca",
  topSnipOffset: 24,
  bottomSnipOffset: 22,
  cutType: 1,
  usForward: 24,
  usReverse: 22,
  isType2S: true
}, {
  aliases: ["PpiI"],
  site: "gaacnnnnnctc",
  forwardRegex: "ga{2}c[abcdghkmnrstvwy]{5}ctc",
  reverseRegex: "gag[abcdghkmnrstvwy]{5}gt{2}c",
  topSnipOffset: 25,
  bottomSnipOffset: 20,
  cutType: 1,
  usForward: 25,
  usReverse: 20,
  isType2S: true
}, {
  aliases: ["BcgI"],
  site: "cgannnnnntgc",
  forwardRegex: "cga[abcdghkmnrstvwy]{6}tgc",
  reverseRegex: "gca[abcdghkmnrstvwy]{6}tcg",
  topSnipOffset: 24,
  bottomSnipOffset: 22,
  cutType: 1,
  usForward: 24,
  usReverse: 22,
  isType2S: true
}, {
  aliases: ["BplI"],
  site: "gagnnnnnctc",
  forwardRegex: "gag[abcdghkmnrstvwy]{5}ctc",
  reverseRegex: "gag[abcdghkmnrstvwy]{5}ctc",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["BsaXI"],
  site: "acnnnnnctcc",
  forwardRegex: "ac[abcdghkmnrstvwy]{5}ctc{2}",
  reverseRegex: "g{2}ag[abcdghkmnrstvwy]{5}gt",
  topSnipOffset: 21,
  bottomSnipOffset: 18,
  cutType: 1,
  usForward: 21,
  usReverse: 18,
  isType2S: true
}, {
  aliases: ["Hin4I"],
  site: "gaynnnnnvtc",
  forwardRegex: "ga[cty][abcdghkmnrstvwy]{5}[acgmrsv]tc",
  reverseRegex: "ga[bcgksty][abcdghkmnrstvwy]{5}[agr]tc",
  topSnipOffset: 24,
  bottomSnipOffset: 19,
  cutType: 1,
  usForward: 24,
  usReverse: 19,
  isType2S: true
}, {
  aliases: ["BaeI"],
  site: "acnnnngtayc",
  forwardRegex: "ac[abcdghkmnrstvwy]{4}gta[cty]c",
  reverseRegex: "g[agr]tac[abcdghkmnrstvwy]{4}gt",
  topSnipOffset: 23,
  bottomSnipOffset: 18,
  cutType: 1,
  usForward: 23,
  usReverse: 18,
  isType2S: true
}, {
  aliases: ["SdeOSI"],
  site: "gacnnnnrtga",
  forwardRegex: "gac[abcdghkmnrstvwy]{4}[agr]tga",
  reverseRegex: "tca[cty][abcdghkmnrstvwy]{4}gtc",
  topSnipOffset: 23,
  bottomSnipOffset: 21,
  cutType: 1,
  usForward: 23,
  usReverse: 21,
  isType2S: true
}];

// aliasedEnzymes.forEach((enz) => {
//   const is2s = isEnzymeType2S(enz);
//   if (is2s) {
//     enz.isType2S = true;
//   }
// });

// require("jsonfile").writeFile(
//   require("path").join(__dirname, "TEMP.json"),
//   aliasedEnzymes,
//   { spaces: 4 },
//   function(err) {
//     if (err) console.error("error writing json", err);
//   }
// );

var aliasedEnzymesByName = {};

aliasedEnzymes.forEach(function (enz) {
  enz.aliases.forEach(function (name) {
    aliasedEnzymesByName[name.toLowerCase()] = _extends({}, enz, { name: name });
  });
});

module.exports = aliasedEnzymesByName;